import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "react-flexbox-grid";
import { Button, DialogContainer, SelectField, TextField } from "react-md";
import { Checkbox } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import "../styles/createAppointmentStyles.css";
import FontIcon from "react-md/lib/FontIcons";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import NavigoDashboardUtils from "../services/NavigoDashboardUtils";
import EventService from "../../../../../service/event/EventService";
import debounce from "debounce";
import { TextField as TextField2 } from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import intToTime12 from "../helper/intToTime12";
import {
  LOCATION_MODE,
  SERVICE_TYPE,
  SERVICE_SUB_TYPE,
  MODES,
  LOCATION_BASED_MODES,
  MODES_WITH_AUTO_SP,
} from "../helper/appointmentConstants";
import {
  LocationSearchDialog,
  useLocationDialog,
} from "../helper/useLocationDialog";
import { useAddressFlow } from "../../../../ops/modules/patients/modules/new-bridge/components/GeoAddress/useAddressFlow";
import AddressFlowDialog from "../../../../ops/modules/patients/modules/new-bridge/components/GeoAddress/AddressFlowDialog";
import TopNote from "../../../../../components/common/TopNote";
import PaymentLinkDialog from "./payFromBridge/PaymentLinkDialog";

export const CreateAccount = (props) => {
  const [totalModes, setTotalModes] = useState([]);
  const [patientIdList, setPatientIdList] = useState([]);
  const [patientDetails, setPatientDetails] = useState(null);
  const [accountList, setAccountList] = useState([]);
  const [accountSelected, setAccountSelected] = useState(null);
  const [planList, setPlanList] = useState([]);
  const [planSelected, setPlanSelected] = useState(null);
  const [serviceTypeList, setServiceTypeList] = useState([]);
  const [serviceTypeSelected, setServiceTypeSelected] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [serviceListToShow, setServiceListToShow] = useState([]);
  const [serviceSelected, setServiceSelected] = useState(null);
  const [serviceModeList, setServiceModeList] = useState([]);
  const [serviceModeSelected, setServiceModeSelected] = useState(null);
  const [selectServiceProviderCheckbox, setSelectServiceProviderCheckbox] =
    useState(false);
  const [serviceProviderList, setServiceProviderList] = useState([]);
  const [serviceProviderListToShow, setServiceProviderListToShow] = useState(
    [],
  );
  const [baseCityListToShow, setBaseCityListToShow] = useState([]);
  const [serviceProviderSelected, setServiceProviderSelected] = useState(null);
  const [gymSubscriptionMetaData, setGymSubscriptionMetaData] = useState(null);
  const [baseCitySelected, setBaseCitySelected] = useState(null);
  const [serviceProviderAutoSelected, setServiceProviderAutoSelected] =
    useState(null);
  const [familyMemberList, setFamilyMemberList] = useState([]);
  const [selectedFamilyMember, setSelectedFamilyMember] = useState(null);
  const [relationsList, setRelationsList] = useState([]);
  const [dateSelected, setDateSelected] = useState(null);
  const [slotList, setSlotList] = useState([]);
  const [slotSelected, setSlotSelected] = useState(null);
  const [patientContactNumber, setPatientContactNumber] = useState(null);
  const [patientContactNumberCheckbox, setPatientContactNumberCheckbox] =
    useState(false);
  const [reasonList, setReasonList] = useState([]);
  const [reasonSelected, setReasonSelected] = useState(null);
  const [reasonDesc, setReasonDesc] = useState("");
  const [stateList, setStateList] = useState([]);
  const [stateSelected, setStateSelected] = useState(null);
  const [cityList, setCityList] = useState([]);
  const [citySelected, setCitySelected] = useState(null);
  const [localityList, setLocalityList] = useState([]);
  const [localitySelected, setLocalitySelected] = useState(null);
  const [addressList, setAddressList] = useState([]);
  const [addressSelected, setAddressSelected] = useState(null);
  const [vendor, setVendor] = useState("");
  const [vendorCode, setVendorCode] = useState("");
  const [providerAddressId, setProviderAddressId] = useState("");
  const [vendorDrId, setVendorDrId] = useState(0);
  const [price, setPrice] = useState(null);
  const [priorityVendorMappedSpIds, setPriorityVendorMappedSpIds] = useState(
    [],
  );
  const [
    addressNotServiceableForPriorityVendors,
    setAddressNotServiceableForPriorityVendors,
  ] = useState(false);
  const [checkAddressServiceableResponse, setCheckAddressServiceableResponse] =
    useState(null);
  const [homeSampleDateMin, setHomeSampleDateMin] = useState(null);
  const [homeSampleDateMax, setHomeSampleDateMax] = useState(null);
  const [availCareDateMin, setAvailCareDateMin] = useState(null);
  const [availCareDateMax, setAvailCareDateMax] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [languageSelected, setLanguageSelected] = useState([]);
  const [updatePatientInfoDialog, setUpdatePatientInfoDialog] = useState(false);
  const [loadingProfileUpdate, setLoadingProfileUpdate] = useState(false);
  const [patientInfo, setPatientInfo] = useState(null);
  const [newDob, setNewDob] = useState(null);
  const [newEmail, setNewEmail] = useState("");
  const [datePickerOpened, setDatePickerOpened] = useState(false);
  const [locationModeSelected, setLocationModeSelected] = useState(null);
  const [geoLocData, setGeoLocData] = useState(null);
  const [rangeOptionSelected, setRangeOptionSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [aptPrice, setAptPrice] = useState(null);
  const [showPaymentLinkDialog, setShowPaymentLinkDialog] = useState(false);
  const [payloadForCreateAppointment, setPayloadForCreateAppointment] =
    useState(null);

  const navigoDashboardUtils = new NavigoDashboardUtils();

  let SELECT_LOCATION_MODE_OPTIONS = [
    {
      label: "Google maps",
      value: LOCATION_MODE.GOOGLE_MAPS,
    },
    {
      label: "Manual",
      value: LOCATION_MODE.MANUAL,
    },
    {
      label: "Saved Addresses",
      value: LOCATION_MODE.SAVED_ADDRESSES,
    },
  ];
  const AUTO_RADIUS_SEQUENCE = [6, 10, 15];

  let LOCATION_RANGE_KMS_OPTIONS = [
    {
      label: "6 Km",
      value: 6,
    },
    {
      label: "10 Km",
      value: 10,
    },
    {
      label: "15 Km",
      value: 15,
    },
    {
      label: "30 Km",
      value: 30,
    },
    {
      label: "50 Km",
      value: 50,
    },
    {
      label: "75 Km",
      value: 75,
    },
    {
      label: "100 Km",
      value: 100,
    },
  ];

  function isAutoSPAllowed(mode) {
    return MODES_WITH_AUTO_SP.includes(mode);
  }

  /* True once the operator has touched the Patient ID field themselves — typed
     into it or picked/cleared an option. A slow URL seed must never overwrite a
     choice they have already made, and typing is the case that matters: while
     the seed GET is in flight patientDetails is still null, so `readOnly:
     !!patientDetails` (2661) is false and onKeyPress (2662-2668) lets digits
     through to onInputChange -> handlePidSearch. Only instrumenting onChange
     would catch a CLEAR and miss a TYPE, and a late seed response would then
     wipe the operator's own search result and force-select the URL patient. */
  const patientTouchedRef = useRef(false);

  /* The ONE place a patient record becomes the selected patient. Lifted out of
     the Patient ID Autocomplete's onChange character for character so the URL
     seed below and a manual pick cannot drift apart — in particular the DOB /
     email gate: a patient missing either is NOT selected, the operator is sent
     to the update-info dialog first, and patientDetails stays null until
     updatePatientInfo's success handler sets it (1774-1775). Injecting straight
     into setPatientDetails would let an operator book for a patient this screen
     refuses to book for.

     isDOBEmpty (1676) and isEmailEmpty (1687) are consts declared further down;
     that is fine because this is only ever CALLED from a handler or an effect,
     i.e. after the whole component body has run — the same reason the onChange
     it came from can call them today. */
  const selectPatient = (v) => {
    if (isDOBEmpty(v) || isEmailEmpty(v)) {
      setPatientInfo(v);
      setUpdatePatientInfoDialog(true);
    } else {
      setPatientDetails(v);
      setPatientContactNumber(v.phoneno);
    }
  };

  /* Patient pre-selection from the URL (/navigo-module?view=1&patientId=…),
     used by the patient-scoped appointments-v2 board so its "Book appointment"
     CTA lands here with that patient already chosen. Runs once, and only when
     the host passed a patientId: NavigoDashboard's own "Add new" passes
     setView(1, null) (NavigoDashboard.js:245), and the other host of this
     screen (slot-margin, which mounts it at view 3, slot-margin/index.js:66)
     only ever sends {from: "SLOT_RESTRICTION_DASHBOARD"}
     (MarginDashboard.js:507). So for every caller that exists today the `if`
     bails on its first statement and this is a no-op, which is also what makes
     props.data being null (the "Add new" case) safe here.

     It fetches with the same call the manual search uses and then runs the same
     selection path, because a patient here is not a display value:
     setPatientDetails is what drives getAccountsForPid / getFamilyMembers /
     gymSubscriptionMetaData (the effect at 269-279) and, through
     accountSelected, getPlansForPid (280-284). Setting a visible field instead
     would look right and do nothing. setPatientIdList([res]) is not cosmetic
     either — it mirrors what handlePidSearch does at :478 before a manual
     onChange fires, and MUI's Autocomplete requires its `value` to be one of
     `options` or it warns and feeds getOptionLabel (2637-2641) an orphan.
     getFamilyMembers is deliberately NOT called from here: it closes over
     patientDetails to unshift the Self row, so it has to run from the effect
     one render later, not against the stale null.

     Failure handling is this path's own choice, not a copy of handlePidSearch
     (which is silent in both arms, 471-490): a lookup that resolves to nothing
     leaves a normal empty Patient ID field the operator can type into, but a
     transport failure toasts, because the operator arrived here having already
     named a patient and would otherwise get a blank field with no explanation.
     The string is this file's existing template (identical at :512, :524, :541,
     :562, :586 and nineteen more sites), so no new copy is introduced. */
  useEffect(() => {
    const seedId = props.data && props.data.patientId;
    if (!seedId) return;
    navigoDashboardUtils.fetchPatientId(
      seedId,
      (res) => {
        if (patientTouchedRef.current) return;
        if (!res || res.id === undefined) return;
        setPatientIdList([res]);
        selectPatient(res);
      },
      (err) => {
        if (patientTouchedRef.current) return;
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  }, []);

  useEffect(() => {
    getModes();
    getAllRelation();
    fetchReasonsForConsultation();
    fetchPriorityVendors();
  }, []);

  useEffect(() => {
    if (patientDetails != null && patientDetails.id) {
      getAccountsForPid(patientDetails.id);
      getFamilyMembers(patientDetails.id);
      setGymSubscriptionMetaData((prev) => ({
        countryCode: patientDetails.countryCode,
        phoneNo: patientDetails.phoneno,
        email: patientDetails.email,
      }));
    }
  }, [patientDetails]);
  useEffect(() => {
    if (accountSelected != null && accountSelected != "") {
      getPlansForPid(patientDetails.id, accountSelected);
    }
  }, [accountSelected]);

  useEffect(() => {
    if (
      addressSelected != null &&
      serviceSelected?.serviceId &&
      hasLocationFilter() === false
    ) {
      checkAddressServiceable(addressSelected);
    }
  }, [addressSelected, selectServiceProviderCheckbox]);

  useEffect(() => {
    if (planSelected != null) {
      setLoading(true);
      let types = totalModes
        .filter((e) => {
          if (
            planSelected.bookConsultation &&
            e.id === SERVICE_TYPE.CONSULTATION
          ) {
            return true;
          } else if (
            planSelected.bookHealthCheckup &&
            e.id === SERVICE_TYPE.HEALTH_CHECKUP
          ) {
            return true;
          } else if (
            planSelected.bookVaccination &&
            e.id === SERVICE_TYPE.VACCINE
          ) {
            return true;
          } else if (planSelected.bookGym && e.id === SERVICE_TYPE.GYM) {
            return true;
          } else if (planSelected.bookDental && e.id === SERVICE_TYPE.DENTAL) {
            return true;
          } else {
            return false;
          }
        })
        .map((e) => {
          return {
            serviceTypeId: e.id,
            serviceTypeName: e.name,
          };
        });
      setServiceTypeList(types);
      setLoading(false);
    }
  }, [planSelected]);

  useEffect(() => {
    // if (serviceTypeSelected != null) {
    //   getServices();
    // }
  }, [serviceTypeSelected]);

  useEffect(() => {
    if (selectedFamilyMember == null) {
      // setPrice(null);
    } else {
      getFamilyDetails();
    }
  }, [selectedFamilyMember]);

  useEffect(() => {
    if (serviceSelected != null) {
      let newList = serviceSelected.serviceModeDetails.map((e) => e.modeName);

      setServiceModeList(newList);
    }
  }, [serviceSelected]);

  useEffect(() => {
    setSelectServiceProviderCheckbox(false);
    setServiceProviderSelected(null);
    setDateSelected(null);
    setSlotSelected(null);
    setSlotList([]);
    if (serviceModeSelected != null) {
      // getProviderOfPlanService(serviceModeSelected);

      if (hasLocationFilter()) {
        getSPLocationState();
      } else {
        getSPByFilters(null, null, null);
      }
      getLanguages(null, null, null);
    }
    if (
      serviceTypeSelected &&
      serviceTypeSelected?.serviceTypeId === SERVICE_TYPE.CONSULTATION &&
      serviceSelected?.serviceTypeId === SERVICE_TYPE.CONSULTATION &&
      serviceSelected?.serviceSubTypeId === SERVICE_SUB_TYPE.AVAIL_CARE
    ) {
      getAvailCareDates();
    } else {
      setAvailCareDateMax(null);
      setAvailCareDateMin(null);
    }
    if (
      serviceModeSelected === MODES.HOME_SAMPLE &&
      serviceSelected.serviceTypeId === SERVICE_TYPE.HEALTH_CHECKUP
    ) {
      getHomeSampleDates();
    } else {
      setHomeSampleDateMin(null);
      setHomeSampleDateMax(null);
    }
  }, [serviceModeSelected]);

  useEffect(() => {
    if (languageSelected && languageSelected?.length > 0) {
      resetValues(8);
      if (serviceSelected) {
        if (
          locationModeSelected?.value === LOCATION_MODE.GOOGLE_MAPS ||
          locationModeSelected?.value === LOCATION_MODE.SAVED_ADDRESSES
        ) {
          getSPByFilters(null, null, null, languageSelected, {
            latLng: geoLocData?.latLng,
            radius: rangeOptionSelected?.value,
            autocheck: false,
          });
        } else {
          getSPByFilters(
            stateSelected,
            citySelected,
            localitySelected,
            languageSelected,
          );
        }
      }
    }
  }, [languageSelected]);

  useEffect(() => {
    if (datePickerOpened === false && dateSelected != null) {
      setSlotSelected(null);
      getAvailableSlots(dateSelected?.format("YYYY-MM-DD"));
    }
  }, [dateSelected]);

  useEffect(() => {
    if (stateSelected != null) {
      getSPLocationCity();
    }
  }, [stateSelected]);
  useEffect(() => {
    if (citySelected != null) {
      getSPLocationLocality();
    }
  }, [citySelected]);

  useEffect(() => {
    if (slotSelected != null) {
      let finalPrice = null;
      if (selectServiceProviderCheckbox) {
        const matchedSP = serviceProviderListToShow.find(
          (sp) => sp.id === serviceProviderAutoSelected,
        );
        finalPrice = matchedSP?.price;
      } else {
        finalPrice = serviceProviderSelected?.price;
      }

      if (finalPrice != null && !isNaN(finalPrice) && finalPrice >= 0) {
        setAptPrice(finalPrice);
      }
    } else {
      setAptPrice(null);
    }
  }, [slotSelected]);

  useEffect(() => {
    if (baseCitySelected != null) {
      let finalPrice = null;
      finalPrice = baseCitySelected?.price;

      if (finalPrice != null && !isNaN(finalPrice) && finalPrice >= 0) {
        setAptPrice(finalPrice);
      }
    } else {
      setAptPrice(null);
    }
  }, [baseCitySelected]);

  const handlePidSearch = useCallback(
    debounce((e, pid) => {
      if (pid && pid.length > 0 && !isNaN(parseInt(pid, 10))) {
        navigoDashboardUtils.fetchPatientId(
          pid,
          (res) => {
            if (res && res.id !== undefined) {
              setPatientIdList([res]);
            } else {
              setPatientIdList([]);
            }
          },
          (err) => {
            setPatientIdList([]);
          },
        );
      }
    }, 300),
    [],
  );

  const getFamilyDetails = () => {
    navigoDashboardUtils.fetchPatientId(
      selectedFamilyMember?.memberPatientId,
      (res) => {
        if (res && res.id != 3) {
          if (isDOBEmpty(res) || isEmailEmpty(res)) {
            setPatientInfo(res);
            setUpdatePatientInfoDialog(true);
          } else {
            // getPrice();
            getServices();
          }
        } else {
          EventService.emit("showError", {
            message: `Patient is inactive`,
          });
        }
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  const getModes = () => {
    const onResponse = (res) => {
      setTotalModes(res == null || res.length === 0 ? [] : res);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getModes(onResponse, onError);
  };

  const getHomeSampleDates = () => {
    const onResponse = (res) => {
      if (res != null) {
        setHomeSampleDateMin(res.minBookingDays);
        setHomeSampleDateMax(res.maxAdvBookingDays);
      }
    };
    const onError = (err) => {
      setHomeSampleDateMin(null);
      setHomeSampleDateMax(null);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getHomeSampleDates(
      patientDetails.id,
      planSelected.planId,
      onResponse,
      onError,
    );
  };
  const getAvailCareDates = () => {
    const onResponse = (res) => {
      if (res != null) {
        setAvailCareDateMin(res.minBookingDays);
        setAvailCareDateMax(res.maxAdvBookingDays);
      }
    };
    const onError = (err) => {
      setAvailCareDateMin(null);
      setAvailCareDateMax(null);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getAvailCareDates(
      patientDetails.id,
      planSelected.planId,
      onResponse,
      onError,
    );
  };

  const getBookingConfigByVendor = (vendorId) => {
    const onResponse = (res) => {
      if (res != null) {
        setHomeSampleDateMin(res.minBookingDays);
        setHomeSampleDateMax(res.maxAdvBookingDays);
      }
      setLoading(false);
    };
    const onError = (err) => {
      setLoading(false);
      setHomeSampleDateMin(null);
      setHomeSampleDateMax(null);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };

    navigoDashboardUtils.getBookingConfigByVendor(
      {
        patientID: patientDetails.id,
        serviceID: serviceSelected.serviceId,
        planID: planSelected.planId,
        vendorId: vendorId,
      },
      onResponse,
      onError,
    );
  };

  const fetchPriorityVendors = () => {
    const onResponse = (res) => {
      const ids =
        res == null || res.length === 0
          ? []
          : res.map((v) => v.mappedServiceProviderId);
      setPriorityVendorMappedSpIds(ids);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getPriorityVendors(onResponse, onError);
  };

  const checkAddressServiceable = (addressSelected) => {
    setAddressNotServiceableForPriorityVendors(false);
    setLoading(true);
    const onResponse = (res) => {
      setCheckAddressServiceableResponse(res);
      if (
        res?.serviceable &&
        serviceSelected?.serviceTypeId === SERVICE_TYPE.VACCINE &&
        selectServiceProviderCheckbox
      ) {
        getBookingConfigByVendor(res?.vendorId);
      } else if (res?.serviceable) {
        setLoading(false);
      } else if (!res?.serviceable) {
        const allArePriorityVendors = serviceProviderListToShow?.every((sp) =>
          priorityVendorMappedSpIds.includes(sp.id),
        );
        if (allArePriorityVendors) {
          setAddressSelected(null);
          setLoading(false);
          EventService.emit("showError", {
            message: `This Address is not serviceable`,
          });
        } else {
          setAddressNotServiceableForPriorityVendors(true);
          setLoading(false);
        }
      }
    };
    const onError = (err) => {
      setLoading(false);
      setCheckAddressServiceableResponse(null);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };

    navigoDashboardUtils.checkAddressServiceable(
      {
        addressId: addressSelected?.id,
        serviceId: serviceSelected?.serviceId,
      },
      onResponse,
      onError,
    );
  };

  const getServices = () => {
    setLoading(true);
    let body = {
      pageNum: 0,
      pageSize: 0,
      planId: planSelected.planId,
      serviceType: serviceTypeSelected.serviceTypeId,
      patientId: patientDetails.id,
      memberPatientId: selectedFamilyMember?.memberPatientId,
      includeSubtypeIds: [],
      excludeSubtypeIds: [],
    };
    const onResponse = (res) => {
      setServiceListToShow(
        res === null || res.services.length === 0 ? [] : res.services,
      );
      setLoading(false);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoading(false);
    };
    navigoDashboardUtils.getServices(body, onResponse, onError);
  };

  const getAccountsForPid = (id) => {
    setLoading(true);

    const onResponse = (res) => {
      if (
        res != null &&
        res.accountCodes != null &&
        res.accountCodes.length != 0
      ) {
        setAccountList(res.accountCodes);
      }
      setLoading(false);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoading(false);
    };

    navigoDashboardUtils.getAccountsForPid(id, onResponse, onError);
  };
  const getPlansForPid = (pid, accId) => {
    setLoading(true);

    const onResponse = (res) => {
      setPlanList(
        res == null || res.length == 0
          ? []
          : res.filter((e) => e.accountCode === accId && e.status === 1),
      );
      setLoading(false);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoading(false);
    };

    navigoDashboardUtils.getPlansForPid(pid, accId, onResponse, onError);
  };

  const getPrice = () => {
    setLoading(true);
    let body = {
      planId: planSelected.planId,
      serviceId: serviceSelected.serviceId,
      patientId: patientDetails.id,
      serviceMode: serviceModeSelected,
      memberPatientId: selectedFamilyMember.memberPatientId,
      memberRelation: selectedFamilyMember.relation,
      sameRelationPIds: familyMemberList
        .filter((e) => e.relation === selectedFamilyMember.relation)
        .map((e) => e.memberPatientId),
    };
    const onResponse = (res) => {
      if (res != null) {
        if (
          res.serviceModeDetails[0].canAvailService === true ||
          res.serviceModeDetails[0].nonServiceAvailabilityReason ===
            "Email is missing"
        ) {
          setPrice(
            res == null ? null : res.serviceModeDetails[0].discountedPrice,
          );
        } else {
          setPrice(null);

          EventService.emit("showError", {
            message: `${res.serviceModeDetails[0].nonServiceAvailabilityReason}`,
          });
        }
      }
      setLoading(false);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoading(false);
    };
    navigoDashboardUtils.getPrice(body, onResponse, onError);
  };

  const getFamilyMembers = (pid) => {
    const onResponse = (res) => {
      let list = res.families;
      list = list.map((e) => {
        return { ...e, dateOfBirth: getAgeYearFromDob(e?.dateOfBirth) };
      });
      list.unshift({
        firstName: patientDetails.firstName,
        lastName: patientDetails.lastName,
        memberPatientId: patientDetails.id,
        gender: patientDetails.gender,
        dateOfBirth: getAgeYearsFromDobMillis(patientDetails?.dateOfBirth),
        relation: 0,
      });

      setFamilyMemberList(list);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getFamilyMembers(pid, onResponse, onError);
  };

  const getAllRelation = () => {
    const onResponse = (res) => {
      let relations = res;
      relations.unshift({ code: 0, value: "Self", gender: 0 });
      setRelationsList(relations);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getAllRelation(onResponse, onError);
  };

  const getAvailableSlots = (date) => {
    setLoading(true);
    let vendor = "";
    let vendorCode = "";
    let vendorDoctorId = 0;
    let providerAddressId = "";

    if (selectServiceProviderCheckbox) {
      vendor = checkAddressServiceableResponse?.vendorId ?? "";
    } else if (serviceProviderSelected) {
      vendor = serviceProviderSelected.vendorId ?? "";
      vendorCode = serviceProviderSelected.vendorCode ?? "";
      vendorDoctorId = serviceProviderSelected.vendorDoctorId ?? 0;
      providerAddressId =
        serviceProviderSelected.address?.providerAddressId ?? "";
    }

    let locationFilter = [];
    if (stateSelected != null && citySelected != null) {
      const filter = { stateMatch: stateSelected, cityMatch: citySelected };
      if (localitySelected != null) filter.landmarkMatch = localitySelected;
      locationFilter.push(filter);
    }

    let body = {
      planId: planSelected.planId,
      serviceId: serviceSelected.serviceId,
      patientId: patientDetails.id,
      serviceProviderId: selectServiceProviderCheckbox
        ? 0
        : serviceProviderSelected?.id == undefined
          ? null
          : serviceProviderSelected.id,
      bookingMode: serviceModeSelected,
      collectionDate: date,
      addressId: addressSelected == null ? null : addressSelected.id,
      vendor,
      vendorCode,
      vendorDoctorId,
      providerAddressId,
      locationFilter,
      languageMatch: languageSelected ?? [],
      memberPatientId:
        selectedFamilyMember.memberPatientId == 0
          ? patientDetails.id
          : selectedFamilyMember.memberPatientId,
      ...(props?.data?.from === "SLOT_RESTRICTION_DASHBOARD" && {
        selectL2Availability: true,
      }),
    };
    const onResponse = (res) => {
      if (res != null && res.date === date) {
        if (res.slots == null) {
          EventService.emit("showError", {
            message: `No slots`,
          });
        }
        setSlotList(res.slots == null ? [] : res.slots);
        setVendor(res.vendorId);
        setVendorCode(res.vendorName);
        setVendorDrId(res.vendorDoctorId);
        setProviderAddressId(res?.providerAddressId ?? "");
        if (selectServiceProviderCheckbox) {
          setServiceProviderAutoSelected(res.serviceProviderId);
        } else {
          setServiceProviderAutoSelected(null);
        }
        setLoading(false);
      }
    };
    const onError = (err) => {
      setVendor("");
      setVendorCode("");
      setProviderAddressId("");
      setVendorDrId(0);
      setServiceProviderAutoSelected(null);
      setSlotList([]);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoading(false);
    };
    navigoDashboardUtils.getAvailableSlots(body, onResponse, onError);
  };

  const fetchReasonsForConsultation = () => {
    const onResponse = (res) => {
      setReasonList(res == null || res.length == 0 ? [] : res);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.fetchReasonsForConsultation(onResponse, onError);
  };

  const handleSave = () => {
    let body = {};
    if (isDataValid()) {
      if (serviceTypeSelected.serviceTypeId == SERVICE_TYPE.CONSULTATION) {
        body = {
          appointmentDate:
            moment(dateSelected).format("YYYY-MM-DD") + "T00:00:00.000Z",
          bookedFor:
            selectedFamilyMember.memberPatientId == patientDetails.id
              ? 0
              : selectedFamilyMember.memberPatientId,
          patientID: patientDetails.id,
          serviceID: serviceSelected.serviceId,
          timeSlot: slotSelected.value,
          timeSlotId: slotSelected.key,
          planID: planSelected.planId,
          mode: serviceModeSelected,
          serviceProviderID: selectServiceProviderCheckbox
            ? serviceProviderAutoSelected
            : serviceProviderSelected?.id,
          isCustomContactNumber: patientContactNumberCheckbox,
          customContactNumber: patientContactNumberCheckbox
            ? {
                countryCode: patientDetails.countryCode,
                phoneNo: patientContactNumber,
              }
            : {
                countryCode: 0,
                phoneNo: 0,
              },
          reportURL: "",
          reasonId: reasonSelected?.id ?? 0,
          reasonDetails: reasonDesc,
          vendorId: vendor,
          vendorCode: vendorCode,
          vendorDoctorId: vendorDrId,
          providerAddressId: providerAddressId,
          ...(props?.data?.from === "SLOT_RESTRICTION_DASHBOARD" && {
            selectL2Availability: true,
          }),
        };
      } else if (
        serviceTypeSelected.serviceTypeId == SERVICE_TYPE.HEALTH_CHECKUP ||
        serviceTypeSelected.serviceTypeId == SERVICE_TYPE.VACCINE ||
        serviceTypeSelected.serviceTypeId == SERVICE_TYPE.DENTAL
      ) {
        body = {
          addressId: addressSelected?.id == null ? null : addressSelected.id,
          appointmentDate:
            moment(dateSelected).format("YYYY-MM-DD") + "T00:00:00.000Z",
          bookedFor:
            selectedFamilyMember.memberPatientId == patientDetails.id
              ? 0
              : selectedFamilyMember.memberPatientId,
          patientID: patientDetails.id,
          serviceID: serviceSelected.serviceId,
          timeSlot: slotSelected.value,
          timeSlotId: slotSelected.key,
          planID: planSelected.planId,
          mode: serviceModeSelected,
          serviceProviderID: selectServiceProviderCheckbox
            ? serviceProviderAutoSelected
            : serviceProviderSelected?.id,
          reportURL: "",
          vendorId: vendor,
          vendorCode: vendorCode,
          vendorDoctorId: vendorDrId,
          ...(props?.data?.from === "SLOT_RESTRICTION_DASHBOARD" && {
            selectL2Availability: true,
          }),
        };
      } else if (serviceTypeSelected.serviceTypeId == SERVICE_TYPE.GYM) {
        body = {
          bookedFor:
            selectedFamilyMember.memberPatientId == patientDetails.id
              ? 0
              : selectedFamilyMember.memberPatientId,
          patientID: patientDetails.id,
          serviceID: serviceSelected.serviceId,
          planID: planSelected.planId,
          mode: serviceModeSelected,
          serviceProviderID: serviceProviderSelected?.id,
          reportURL: "",
          gymMetadata: {
            ...gymSubscriptionMetaData,
            cityId: baseCitySelected?.cityId,
          },
        };
      }
      // createAppointment(body);
      startPaymentLinkFlow(body);
    }
  };

  const isDataValid = () => {
    if (
      !patientDetails?.id ||
      !Number.isInteger(patientDetails.id) ||
      patientDetails.id <= 0
    ) {
      EventService.emit("showError", {
        message: "Please enter valid patient details",
      });
      return;
    } else if (accountSelected == null) {
      EventService.emit("showError", {
        message: "Please select an account",
      });
      return;
    } else if (planSelected == null) {
      EventService.emit("showError", {
        message: "Please select a plan",
      });
      return;
    } else if (serviceTypeSelected == null) {
      EventService.emit("showError", {
        message: "Please select a service type",
      });
      return;
    } else if (serviceSelected == null) {
      EventService.emit("showError", {
        message: "Please select a service",
      });
      return;
    } else if (serviceModeSelected == null) {
      EventService.emit("showError", {
        message: "Please select a service mode",
      });
      return;
    } else if (
      selectServiceProviderCheckbox == false &&
      serviceProviderSelected == null
    ) {
      EventService.emit("showError", {
        message: "Please select a service provider",
      });
      return;
    } else if (selectedFamilyMember == null) {
      EventService.emit("showError", {
        message: "Please select a booking for member",
      });
      return;
    } else if (
      !(serviceTypeSelected.serviceTypeId == SERVICE_TYPE.GYM) &&
      dateSelected == null
    ) {
      // do not check dateselected if serviceType is GYM
      EventService.emit("showError", {
        message: "Please select an appointment date",
      });
      return;
    } else if (
      !(serviceTypeSelected.serviceTypeId == SERVICE_TYPE.GYM) &&
      slotSelected == null
    ) {
      EventService.emit("showError", {
        message: "Please select a time slot",
      });
      return;
    } else {
      if (serviceTypeSelected.serviceTypeId == SERVICE_TYPE.CONSULTATION) {
        if (serviceModeSelected != MODES.IN_PERSON_CONSULTATION) {
          if (
            patientContactNumberCheckbox &&
            (!Number.isInteger(patientContactNumber) ||
              patientContactNumber.toString().length != 10)
          ) {
            EventService.emit("showError", {
              message: "Please enter a valid patient contact number",
            });
            return;
          } else if (reasonSelected == null) {
            EventService.emit("showError", {
              message: "Please select a reason for consultation",
            });
            return;
          } else if (reasonSelected.id == 6 && reasonDesc == "") {
            EventService.emit("showError", {
              message: "Please describe the reason",
            });
            return;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else if (
        serviceTypeSelected.serviceTypeId == SERVICE_TYPE.HEALTH_CHECKUP ||
        serviceTypeSelected.serviceTypeId == SERVICE_TYPE.VACCINE ||
        serviceTypeSelected.serviceTypeId == SERVICE_TYPE.DENTAL
      ) {
        if (
          serviceModeSelected === MODES.HOME_SAMPLE &&
          addressSelected == null
        ) {
          EventService.emit("showError", {
            message: "Please select an address",
          });
          return;
        } else {
          return true;
        }
      } else if (serviceTypeSelected.serviceTypeId == SERVICE_TYPE.GYM) {
        if (
          (baseCityListToShow ?? []).length > 0 &&
          (baseCitySelected?.cityId ?? "") == ""
        ) {
          EventService.emit("showError", {
            message: "Please select a base city",
          });
          return;
        } else if (
          !gymSubscriptionMetaData?.countryCode ||
          !gymSubscriptionMetaData?.phoneNo ||
          !isValidPhoneNo(gymSubscriptionMetaData?.phoneNo)
        ) {
          EventService.emit("showError", {
            message: "Please enter a valid subscription mobile number",
          });
          return;
        } else if (
          !gymSubscriptionMetaData?.email ||
          !isValidEmail(gymSubscriptionMetaData?.email ?? "")
        ) {
          EventService.emit("showError", {
            message: "Please enter a valid subscription email ID",
          });
          return;
        } else {
          return true;
        }
      }
    }

    return false;
  };
  const createAppointment = (body) => {
    setLoading(true);
    const onResponse = (res) => {
      EventService.emit("showError", {
        message: `Appointment created`,
      });
      setLoading(false);
      props.resetDashboard();
      exitPage();
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoading(false);
    };
    navigoDashboardUtils.createAppointment(body, onResponse, onError);
  };

  const startPaymentLinkFlow = (body) => {
    setPayloadForCreateAppointment(body);
    setLoading(true);
    setShowPaymentLinkDialog(true);
  };

  const getSPLocationState = () => {
    let body = {
      type: "state",
      planId: planSelected.planId,
      serviceId: serviceSelected.serviceId,
      serviceMode: serviceModeSelected,
    };

    const onResponse = (res) => {
      setStateList(
        res == null || res.state == null || res.state.length == 0
          ? []
          : res.state,
      );
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getSPLocation(body, onResponse, onError);
  };
  const getSPLocationCity = () => {
    setLoading(true);
    let body = {
      type: "city",
      state: stateSelected,
      planId: planSelected.planId,
      serviceId: serviceSelected.serviceId,
      serviceMode: serviceModeSelected,
    };

    const onResponse = (res) => {
      setCityList(
        res == null || res.city == null || res.city.length == 0 ? [] : res.city,
      );
      setLoading(false);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoading(false);
    };
    navigoDashboardUtils.getSPLocation(body, onResponse, onError);
  };
  const getSPLocationLocality = () => {
    setLoading(true);
    let body = {
      type: "locality",
      state: stateSelected,
      city: citySelected,
      planId: planSelected.planId,
      serviceId: serviceSelected.serviceId,
      serviceMode: serviceModeSelected,
    };

    const onResponse = (res) => {
      setLocalityList(
        res == null || res.locality == null || res.locality.length == 0
          ? []
          : res.locality,
      );
      getSPByFilters(stateSelected, citySelected, null);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoading(false);
    };
    navigoDashboardUtils.getSPLocation(body, onResponse, onError);
  };

  const hasLocationFilter = () => {
    return LOCATION_BASED_MODES.includes(serviceModeSelected);
  };

  const findRangeOptionByRadius = (radius) =>
    LOCATION_RANGE_KMS_OPTIONS.find((opt) => opt.value === radius) || null;

  const getSPByFilters = (
    state,
    city,
    locality,
    lang,
    range,
    filters = {},
    onResponseCallback = null,
  ) => {
    // If location-based mode but missing state or city, skip API call.
    if (hasLocationFilter() && (!state || !city) && !range) {
      // Directly set empty lists, do not set loading
      setServiceProviderList([]);
      setServiceProviderListToShow([]);
      return;
    }

    setLoading(true);

    const executeCall = (currentRange, autoIndex = 0) => {
      let body = {
        pageNum: 0,
        pageSize: 0,
        planId: planSelected.planId,
        serviceId: serviceSelected.serviceId,
        serviceMode: serviceModeSelected,
        patientId: patientDetails.id,
        memberPatientId: selectedFamilyMember.memberPatientId,
        languageMatch: lang ?? [],
        ...(filters ?? {}),
        locationFilter: [],
        geolocationFilter:
          range?.latLng && currentRange
            ? {
                longitude: range.latLng.lng,
                latitude: range.latLng.lat,
                radius: currentRange.radius * 1000, // Convert km to meters
              }
            : null,
        ...(props?.data?.from === "SLOT_RESTRICTION_DASHBOARD" && {
          selectL2Availability: true,
        }),
      };

      // Add location filters only if state and city both are provided
      if (state != null) {
        const filter = { stateMatch: state };
        if (city != null) filter.cityMatch = city;
        if (locality != null) filter.landmarkMatch = locality;
        body.locationFilter.push(filter);
      }

      const onResponse = (res) => {
        if (onResponseCallback) {
          onResponseCallback(res);
          return;
        }
        const providers =
          res?.providers && res.providers.length > 0 ? res.providers : [];

        if (providers.length > 0) {
          setServiceProviderList(providers);
          setServiceProviderListToShow(providers);
          setLoading(false);
          return;
        }

        // AUTO-CHECK RETRY LOGIC
        if (
          currentRange?.autocheck === true &&
          autoIndex < AUTO_RADIUS_SEQUENCE.length - 1
        ) {
          const nextRadius = AUTO_RADIUS_SEQUENCE[autoIndex + 1];

          // update selected dropdown option
          const nextRangeOpt = findRangeOptionByRadius(nextRadius);
          if (nextRangeOpt) {
            setRangeOptionSelected(nextRangeOpt);
          }

          executeCall(
            { radius: nextRadius, autocheck: true, latLng: range.latLng },
            autoIndex + 1,
          );
          return;
        }

        // Not found even after retries of 3 radius levels
        setServiceProviderList([]);
        setServiceProviderListToShow([]);
        setLoading(false);

        EventService.emit("showError", {
          message: "No service provider found",
        });
      };

      const onError = (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
        setLoading(false);
      };

      navigoDashboardUtils.getServiceProvider(body, onResponse, onError);
    };

    // START CALL
    executeCall(range, AUTO_RADIUS_SEQUENCE.indexOf(range?.radius));
  };

  const getPatientAddress = () => {
    const onResponse = (res) => {
      setAddressList(res == null || res.length == 0 ? [] : res);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getPatientAddress(
      patientDetails.id,
      onResponse,
      onError,
    );
  };
  const getLanguages = (state, city, locality) => {
    // Only apply language filter for serviceTypeId === 1
    if (serviceTypeSelected?.serviceTypeId !== SERVICE_TYPE.CONSULTATION) {
      setLanguageSelected([]);
      setLanguages([]);
      return;
    }

    // Handle In person consultation (location-based)
    if (serviceModeSelected === MODES.IN_PERSON_CONSULTATION) {
      // Check latest state and city
      if (!state || !city) {
        setLanguageSelected([]);
        setLanguages([]);
        return;
      }

      // Build location filter using latest values
      const locationFilter = [
        {
          stateMatch: state,
          cityMatch: city,
          ...(locality ? { landmarkMatch: locality } : {}),
        },
      ];

      fetchLanguages(locationFilter);
      return;
    }

    // Handle Tele / Video consultation (non-location)
    if (
      serviceModeSelected === MODES.TELE_CONSULTATION ||
      serviceModeSelected === MODES.VIDEO_CONSULTATION
    ) {
      fetchLanguages([]); // API call with empty locationFilter
      return;
    }

    // Any other mode → clear languages
    setLanguageSelected([]);
    setLanguages([]);
  };

  // Helper to make the API call
  const fetchLanguages = (locationFilter) => {
    const body = {
      planId: planSelected.planId,
      serviceId: serviceSelected.serviceId,
      serviceMode: serviceModeSelected,
      locationFilter,
    };

    const onResponse = (res) => {
      setLanguageSelected([]);
      setLanguages(res?.languages?.length > 0 ? res.languages : []);
    };

    const onError = (err) => {
      setLanguageSelected([]);
      setLanguages([]);
      EventService.emit("showError", { message: `Error: ${err?.message}` });
    };

    navigoDashboardUtils.getLanguages(body, onResponse, onError);
  };

  const exitPage = () => {
    resetValues();
    props.setView(0);
  };
  // Home Sample: a provider whose id matches a priority vendor's
  // mappedServiceProviderId uses the global booking config; every other
  // (non-priority) provider uses its own booking days.
  const usesGlobalBookingConfig = (serviceProviderSelected) => {
    if (serviceProviderSelected == null) {
      return true;
    }
    return priorityVendorMappedSpIds.includes(serviceProviderSelected.id);
  };
  function getMinDate1(selectServiceProviderCheckbox, serviceProviderSelected) {
    if (
      serviceSelected?.serviceTypeId === SERVICE_TYPE.CONSULTATION &&
      serviceSelected?.serviceSubTypeId === SERVICE_SUB_TYPE.AVAIL_CARE
    ) {
      if (availCareDateMin == null) {
        return moment();
      } else {
        return moment().add(availCareDateMin, "days");
      }
    }
    if (selectServiceProviderCheckbox) {
      return moment();
    }

    const minDays = serviceProviderSelected?.minBookingDays;

    if (minDays === undefined) {
      return moment();
    }

    return moment().add(minDays, "days");
  }
  function getMaxDate1(selectServiceProviderCheckbox, serviceProviderSelected) {
    if (
      serviceSelected?.serviceTypeId === SERVICE_TYPE.CONSULTATION &&
      serviceSelected?.serviceSubTypeId === SERVICE_SUB_TYPE.AVAIL_CARE
    ) {
      if (availCareDateMax == null) {
        return undefined;
      } else {
        return moment().add(availCareDateMax - 1, "days");
      }
    }
    if (selectServiceProviderCheckbox) {
      return undefined;
    }

    const maxDays = serviceProviderSelected?.maxBookingDays;

    if (maxDays === undefined) {
      return undefined;
    }

    return moment().add(maxDays - 1, "days");
  }
  function getMinDate2(
    serviceModeSelected,
    homeSampleDateMin,
    selectServiceProviderCheckbox,
    serviceProviderSelected,
  ) {
    if (
      serviceModeSelected === MODES.HOME_SAMPLE &&
      !(
        serviceSelected?.serviceTypeId === SERVICE_TYPE.VACCINE &&
        !selectServiceProviderCheckbox
      )
    ) {
      if (usesGlobalBookingConfig(serviceProviderSelected)) {
        if (homeSampleDateMin == null) {
          return moment();
        } else {
          return moment().add(homeSampleDateMin, "days");
        }
      }
      const providerMinDays = serviceProviderSelected?.minBookingDays;
      if (providerMinDays === undefined) {
        return moment();
      }
      return moment().add(providerMinDays, "days");
    }

    if (selectServiceProviderCheckbox) {
      return moment();
    }

    const minDays = serviceProviderSelected?.minBookingDays;

    if (minDays === undefined) {
      return moment();
    }

    return moment().add(minDays, "days");
  }
  function getMaxDate2(
    serviceModeSelected,
    homeSampleDateMax,
    selectServiceProviderCheckbox,
    serviceProviderSelected,
  ) {
    if (
      serviceModeSelected === MODES.HOME_SAMPLE &&
      !(
        serviceSelected?.serviceTypeId === SERVICE_TYPE.VACCINE &&
        !selectServiceProviderCheckbox
      )
    ) {
      if (usesGlobalBookingConfig(serviceProviderSelected)) {
        if (homeSampleDateMax == null) {
          return undefined;
        } else {
          return moment().add(homeSampleDateMax - 1, "days");
        }
      }
      const providerMaxDays = serviceProviderSelected?.maxBookingDays;
      if (providerMaxDays === undefined) {
        return undefined;
      }
      return moment().add(providerMaxDays - 1, "days");
    }

    if (selectServiceProviderCheckbox) {
      return undefined;
    }

    const maxDays = serviceProviderSelected?.maxBookingDays;

    if (maxDays === undefined) {
      return undefined;
    }

    return moment().add(maxDays - 1, "days");
  }
  //--------
  function areDatesAvailable1(
    selectServiceProviderCheckbox,
    serviceProviderSelected,
  ) {
    let minDays, maxDays;

    if (
      serviceSelected.serviceTypeId === SERVICE_TYPE.CONSULTATION &&
      serviceSelected.serviceSubTypeId === SERVICE_SUB_TYPE.AVAIL_CARE
    ) {
      minDays = availCareDateMin ?? 0;
      maxDays = availCareDateMax ?? 0;
    } else if (selectServiceProviderCheckbox) {
      return true;
    } else {
      minDays = serviceProviderSelected?.minBookingDays ?? 0;
      maxDays = serviceProviderSelected?.maxBookingDays ?? 0;
    }

    if (minDays === maxDays) {
      EventService.emit("showError", { message: "Dates not available" });
      return false;
    }

    return true;
  }

  function areDatesAvailable2(
    serviceModeSelected,
    homeSampleDateMin,
    homeSampleDateMax,
    selectServiceProviderCheckbox,
    serviceProviderSelected,
  ) {
    if (
      serviceModeSelected === MODES.HOME_SAMPLE &&
      !(
        serviceSelected?.serviceTypeId === SERVICE_TYPE.VACCINE &&
        !selectServiceProviderCheckbox
      )
    ) {
      if (usesGlobalBookingConfig(serviceProviderSelected)) {
        if (
          homeSampleDateMax === homeSampleDateMin &&
          homeSampleDateMin != null &&
          homeSampleDateMax != null
        ) {
          EventService.emit("showError", {
            message: `Dates not available`,
          });
          return false;
        } else {
          return true;
        }
      }
      const providerMinDays = serviceProviderSelected?.minBookingDays;
      const providerMaxDays = serviceProviderSelected?.maxBookingDays;
      if (providerMinDays === providerMaxDays) {
        EventService.emit("showError", {
          message: `Dates not available`,
        });
        return false;
      }
      return true;
    }

    if (selectServiceProviderCheckbox) {
      return true;
    }

    const minDays = serviceProviderSelected?.minBookingDays;
    const maxDays = serviceProviderSelected?.maxBookingDays;

    if (minDays === maxDays) {
      EventService.emit("showError", {
        message: `Dates not available`,
      });
      return false;
    } else {
      return true;
    }
  }

  const closePatientInfoDialog = () => {
    setNewDob(null);
    setNewEmail("");
    setPatientInfo(null);
    setUpdatePatientInfoDialog(false);
  };
  const isDOBEmpty = (patient) => {
    const dob = patient?.dateOfBirth;
    return (
      dob === undefined ||
      dob === null ||
      dob === "" ||
      isNaN(dob) ||
      Number(dob) === 0
    );
  };

  const isEmailEmpty = (patient) => {
    const email = patient?.email;
    return (
      email === undefined ||
      email === null ||
      typeof email !== "string" ||
      email.trim() === ""
    );
  };

  const isValidPhoneNo = (phone) => {
    const regex = /^[0-9]{10}$/;

    return regex.test(phone);
  };
  const isValidEmail = (email) => {
    if (
      typeof email !== "string" ||
      email.trim() === "" ||
      !email.includes("@")
    ) {
      return false;
    }

    const [localPart, domain] = email.trim().split("@");

    if (!localPart || !domain) return false;

    const isValidEmailDomain = (domain) =>
      /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(domain);

    return isValidEmailDomain(domain);
  };

  const updatePatientInfo = (patient) => {
    if (isDOBEmpty(patient) && newDob === null) {
      EventService.emit("showError", {
        message: `Please fill the Date of birth`,
      });
      return;
    }
    if (
      isEmailEmpty(patient) &&
      newEmail !== "" &&
      isValidEmail(newEmail) === false
    ) {
      EventService.emit("showError", {
        message: `Please enter a valid email address`,
      });
      return;
    }
    const body = {
      patientId: patient.id,
      firstName: patient.firstName,
      lastName: patient.lastName ? patient.lastName : null,
      gender: patient.gender,
      dateOfBirth: isDOBEmpty(patient)
        ? moment(newDob).format("YYYY-MM-DD")
        : moment(patient.dateOfBirth).format("YYYY-MM-DD"),
      phoneNo: String(patient.phoneno),
      email: newEmail !== "" ? newEmail : patient.email,
      profileImage: patient.profileImage,
      countryCode: patient.countryCode,
    };

    const onResponse = (res) => {
      if (selectedFamilyMember != null) {
        EventService.emit("showError", {
          message: `Information updated`,
        });
        // setSelectedFamilyMember(null);

        setLoadingProfileUpdate(false);
        closePatientInfoDialog();
        getServices();
        // getPrice();
      } else {
        let newPatient = { ...patientInfo };
        if (newDob !== null) {
          newPatient = {
            ...newPatient,
            dateOfBirth: moment(newDob).format("YYYY-MM-DD"),
          };
        }
        if (newEmail !== "") {
          newPatient = { ...newPatient, email: newEmail };
        }
        setPatientDetails(newPatient);
        setPatientContactNumber(newPatient?.phoneno);
        EventService.emit("showError", {
          message: `Information updated`,
        });

        setLoadingProfileUpdate(false);
        closePatientInfoDialog();
      }
    };
    const onError = (err) => {
      setSelectedFamilyMember(null);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoadingProfileUpdate(false);
    };

    if (!isDOBEmpty(patient) && newEmail === "") {
      onResponse("");
    } else {
      setLoadingProfileUpdate(true);
      navigoDashboardUtils.updateProfileInfo(body, onResponse, onError);
    }
  };

  const getSPLabelTypeConsult = (option, serviceModeSelected) => {
    if (!option) return "";

    const isApolloSP = option.vendorDoctorId && option.vendorDoctorId !== 0;

    const doctorId = isApolloSP ? option.vendorDoctorId : option.id;

    const locationText = isApolloSP
      ? (option?.address?.housing ?? "")
      : `${option?.address?.city ?? ""} - ${option?.address?.landmark ?? ""}`;

    if (serviceModeSelected === MODES.IN_PERSON_CONSULTATION) {
      return `(${doctorId}) ${option.name} - ${locationText} (Rs ${option.price})${
        (locationModeSelected?.value === LOCATION_MODE.GOOGLE_MAPS ||
          locationModeSelected?.value === LOCATION_MODE.SAVED_ADDRESSES) &&
        option?.distanceFromSource >= 0
          ? ` [${formatDistanceKm(option.distanceFromSource)}]`
          : ""
      }`;
    }

    return `(${option.id}) ${option.name} (Rs ${option.price})`;
  };

  const getSPLabelTypeHC = (option, serviceModeSelected) => {
    if (!option) return "";

    const showAddress =
      serviceModeSelected === MODES.CENTRE_VISIT ||
      serviceModeSelected === MODES.CAMP_SITE_VISIT;

    const addressPart = showAddress
      ? ` - ${option?.address?.city ?? ""} - ${option?.address?.landmark ?? ""}`
      : "";

    return `(${option.id}) ${option.name}${addressPart} (Rs ${option.price})${
      (locationModeSelected?.value === LOCATION_MODE.GOOGLE_MAPS ||
        locationModeSelected?.value === LOCATION_MODE.SAVED_ADDRESSES) &&
      option?.distanceFromSource >= 0
        ? ` [${formatDistanceKm(option.distanceFromSource)}]`
        : ""
    }`;
  };

  function getAgeFromDob(dobMillis) {
    const dob = moment(dobMillis);
    const now = moment();

    let years = now.diff(dob, "years");
    const adjustedDob = dob.clone().add(years, "years");
    let months = now.diff(adjustedDob, "months");

    // Adjust if the current date is before the birth day of the month
    if (months < 0) {
      years--;
      months += 12;
    }

    const yearStr = `${years} year${years === 1 ? "" : "s"}`;
    const monthStr =
      months > 0 ? ` ${months} month${months === 1 ? "" : "s"}` : "";

    return `${yearStr}${monthStr}`;
  }

  function getAgeYearsFromDobMillis(dobMillis) {
    if (!dobMillis) return "-";

    const dob = moment(dobMillis);
    if (!dob.isValid()) return "-";

    const now = moment();
    let years = now.diff(dob, "years");
    const adjustedDob = dob.clone().add(years, "years");
    let months = now.diff(adjustedDob, "months");

    if (months < 0) {
      years--;
      months += 12;
    }

    return `${years}`;
  }

  function getAgeYearFromDob(dobStr) {
    if (!dobStr) return "-";

    const dob = moment(dobStr, "YYYY-MM-DD", true);
    if (!dob.isValid()) return "-";

    const now = moment();
    const years = now.diff(dob, "years");

    return `${years}`;
  }

  // Location Picker Dialog

  const { dialogState, setDialogState, openLocationDialog, closeDialog } =
    useLocationDialog();

  // Address edit flow (for addresses without valid coordinates)
  const {
    dialogState: addrEditDialogState,
    setDialogState: addrEditSetDialogState,
    openLocationDialog: addrEditOpenLocationDialog,
    closeDialog: addrEditCloseDialog,
  } = useLocationDialog();

  const {
    flowState: addrFlowState,
    setFlowState: setAddrFlowState,
    openAddressFlow,
    closeFlow: closeAddrFlow,
  } = useAddressFlow();

  const handleAddressSelectWithValidation = async (v) => {
    const hasValidCoordinates =
      v?.coordinates &&
      v.coordinates.latitude !== 0 &&
      v.coordinates.longitude !== 0;

    if (!hasValidCoordinates) {
      let initialLocationData = null;
      if (v?.id) {
        try {
          const res = await getCoordinatesFromAddressId(v.id);
          const lat = res?.latitude;
          const lng = res?.longitude;
          if (
            typeof lat === "number" &&
            typeof lng === "number" &&
            !(lat === 0 && lng === 0)
          ) {
            initialLocationData = {
              latLng: { lat, lng },
              address: null,
              selectedLabel: "",
            };
          }
        } catch (e) {
          // ignore — map will open without an initial pin
        }
      }

      const result = await openAddressFlow({
        ...v,
        coordinates: v.coordinates || null,
        initialLocationData,
      });

      if (result?.confirmed) {
        setAddressSelected(result.data);
      }
    } else {
      setAddressSelected(v);
    }
  };

  const handleOpenLocationPicker = async () => {
    const result = await openLocationDialog(geoLocData);

    if (result?.confirmed) {
      const { latLng, address, selectedLabel, query } = result;

      const dataToStore = {
        latLng,
        address,
        selectedLabel,
        query,
      };
      resetValues(11);
      setGeoLocData(dataToStore);
      setTimeout(() => {
        handleRadiusKmSelected(
          LOCATION_RANGE_KMS_OPTIONS[0],
          true,
          dataToStore.latLng,
        );
        if (serviceTypeSelected.serviceTypeId === SERVICE_TYPE.CONSULTATION) {
          fetchLanguages([]);
        }
      }, 0);
    } else {
    }
  };

  const getCoordinatesFromAddressId = (addressId) => {
    return new Promise((resolve, reject) => {
      const onResponse = (res) => {
        resolve(res);
      };

      const onError = (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
        reject(err);
      };

      navigoDashboardUtils.getCoordinatesFromAddressId(
        addressId,
        onResponse,
        onError,
      );
    });
  };

  const getLocationFromSavedAddress = async (addressSelected) => {
    if (!addressSelected) {
      setLoading(false);
      return;
    }

    let lat = null;
    let lng = null;

    const coords = addressSelected?.coordinates;

    // Case 1: Coordinates already exist and are valid
    if (
      coords &&
      typeof coords.latitude === "number" &&
      typeof coords.longitude === "number" &&
      !(coords.latitude === 0 && coords.longitude === 0)
    ) {
      lat = coords.latitude;
      lng = coords.longitude;
    }
    // Case 2: Need to fetch from API
    else {
      try {
        const res = await getCoordinatesFromAddressId(addressSelected?.id);

        lat = res?.latitude;
        lng = res?.longitude;

        if (
          typeof lat !== "number" ||
          typeof lng !== "number" ||
          (lat === 0 && lng === 0)
        ) {
          throw new Error("Invalid coordinates received");
        }
      } catch (error) {
        setLoading(false);
        setAddressSelected(null);
        return; // stop execution if API fails
      }
    }

    const dataToStore = {
      latLng: {
        lat,
        lng,
      },
      address: null,
      selectedLabel: null,
    };

    setGeoLocData(dataToStore);

    // Set address selected immediately after reset to avoid race conditions
    setAddressSelected(addressSelected);

    // Use setTimeout to ensure state updates are processed before fetching service providers
    setTimeout(() => {
      handleRadiusKmSelected(
        LOCATION_RANGE_KMS_OPTIONS[0],
        true,
        dataToStore.latLng,
      );
      if (serviceTypeSelected.serviceTypeId === SERVICE_TYPE.CONSULTATION) {
        fetchLanguages([]);
      }
    }, 0);
  };

  function formatAddress(address) {
    if (!address || typeof address !== "object") return "";

    const fieldsInOrder = [
      address.building,
      address.street,
      address.landmark,
      address.neighborhood,
      address.subLocality,
      address.localityArea,
      address.city,
      address.subDistrict,
      address.district,
      address.state,
      address.pincode,
      address.country,
    ];

    return fieldsInOrder
      .filter((value) => typeof value === "string" && value.trim().length > 0)
      .join(", ");
  }

  function handleRadiusKmSelected(rangeOpt, autocheck = false, latLng = null) {
    const radius = rangeOpt?.value;
    const hasValidRadius = Number.isFinite(radius) && radius > 0;
    const hasLatLng = latLng?.lat != null && latLng?.lng != null;

    if (!hasValidRadius || !hasLatLng) {
      setRangeOptionSelected(null);
      return;
    }

    setRangeOptionSelected(rangeOpt);
    getSPByFilters(null, null, null, null, {
      latLng,
      radius,
      autocheck: Boolean(autocheck),
    });
  }

  const formatDistanceKm = (distanceInMeters) => {
    if (typeof distanceInMeters !== "number") return "";
    return `${(distanceInMeters / 1000).toFixed(2)} km away`;
  };

  const renderTotalAmountAndCreateAptBtn = () => {
    return (
      <>
        {/* Show Total Amount only if aptPrice exists */}
        {typeof aptPrice === "number" && aptPrice >= 0 && (
          <>
            <br />
            <Row>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">{`Total amount`}</div>
                  <div>
                    <TextField
                      value={`Rs ${aptPrice}`}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </>
        )}

        {/* Always show buttons */}
        <>
          <br />
          <Row>
            <Col xs={12} sm={7} md={5} lg={5}>
              <div className="navigo-module-create-service-field-container">
                <Button
                  raised
                  disabled={loading}
                  className={
                    loading
                      ? "navigo-module-button-save-disabled"
                      : "navigo-module-button-save-enabled"
                  }
                  onClick={handleSave}
                >
                  {typeof aptPrice === "number" && aptPrice > 0
                    ? "Create appointment & proceed to pay"
                    : "Create appointment"}
                </Button>
              </div>
            </Col>
          </Row>
        </>
      </>
    );
  };

  const resetValues = (code) => {
    switch (code) {
      case 1: // after patient id change
        setPatientIdList([]);
        setPatientDetails(null);
        setAccountList([]);
        setAccountSelected(null);
        setPlanList([]);
        setPlanSelected(null);
        setServiceTypeList([]);
        setServiceTypeSelected(null);
        setServiceList([]);
        setServiceListToShow([]);
        setServiceSelected(null);
        setServiceModeList([]);
        setServiceModeSelected(null);
        setLocationModeSelected(null);
        setGeoLocData(null);
        setRangeOptionSelected(null);
        setSelectServiceProviderCheckbox(false);
        setServiceProviderList([]);
        setServiceProviderListToShow([]);
        setBaseCityListToShow([]);
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setFamilyMemberList([]);
        setSelectedFamilyMember(null);
        setDateSelected(null);
        setSlotList([]);
        setSlotSelected(null);
        setPatientContactNumber(null);
        setPatientContactNumberCheckbox(false);
        setReasonSelected(null);
        setReasonDesc("");
        setStateList([]);
        setStateSelected(null);
        setCityList([]);
        setCitySelected(null);
        setLocalityList([]);
        setLocalitySelected(null);
        setAddressList([]);
        setAddressSelected(null);
        setLanguageSelected([]);
        setLanguages([]);
        setBaseCitySelected(null);
        setLoading(false);
        break;
      case 2: // after account change
        setPlanList([]);
        setPlanSelected(null);
        setServiceTypeList([]);
        setServiceTypeSelected(null);
        setServiceList([]);
        setServiceListToShow([]);
        setServiceSelected(null);
        setServiceModeList([]);
        setServiceModeSelected(null);
        setLocationModeSelected(null);
        setGeoLocData(null);
        setRangeOptionSelected(null);
        setSelectServiceProviderCheckbox(false);
        setServiceProviderList([]);
        setServiceProviderListToShow([]);
        setBaseCityListToShow([]);
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setSelectedFamilyMember(null);
        setDateSelected(null);
        setSlotList([]);
        setSlotSelected(null);
        setPatientContactNumberCheckbox(false);
        setReasonSelected(null);
        setReasonDesc("");
        setStateList([]);
        setStateSelected(null);
        setCityList([]);
        setCitySelected(null);
        setLocalityList([]);
        setLocalitySelected(null);
        setAddressList([]);
        setAddressSelected(null);
        setLanguageSelected([]);
        setLanguages([]);
        setBaseCitySelected(null);
        setLoading(false);
        break;

      case 3: // after plan selection change
        setServiceTypeList([]);
        setServiceTypeSelected(null);
        setServiceList([]);
        setServiceListToShow([]);
        setServiceSelected(null);
        setServiceModeList([]);
        setServiceModeSelected(null);
        setLocationModeSelected(null);
        setGeoLocData(null);
        setRangeOptionSelected(null);
        setSelectServiceProviderCheckbox(false);
        setServiceProviderList([]);
        setServiceProviderListToShow([]);
        setBaseCityListToShow([]);
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setSelectedFamilyMember(null);
        setDateSelected(null);
        setSlotList([]);
        setSlotSelected(null);
        setPatientContactNumberCheckbox(false);
        setReasonSelected(null);
        setReasonDesc("");
        setStateList([]);
        setStateSelected(null);
        setCityList([]);
        setCitySelected(null);
        setLocalityList([]);
        setLocalitySelected(null);
        setAddressList([]);
        setAddressSelected(null);
        setLanguageSelected([]);
        setLanguages([]);
        setBaseCitySelected(null);
        setLoading(false);
        break;

      case 4: // after service type change
        setServiceListToShow([]);
        setServiceSelected(null);
        setServiceModeList([]);
        setServiceModeSelected(null);
        setLocationModeSelected(null);
        setGeoLocData(null);
        setRangeOptionSelected(null);
        setSelectServiceProviderCheckbox(false);
        setServiceProviderList([]);
        setServiceProviderListToShow([]);
        setBaseCityListToShow([]);
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setSelectedFamilyMember(null);
        setDateSelected(null);
        setSlotList([]);
        setSlotSelected(null);
        setStateList([]);
        setStateSelected(null);
        setCityList([]);
        setCitySelected(null);
        setLocalityList([]);
        setLocalitySelected(null);
        setAddressList([]);
        setAddressSelected(null);
        setLanguageSelected([]);
        setLanguages([]);
        setBaseCitySelected(null);
        setLoading(false);
        break;

      case 5: // after service code change
        setServiceModeList([]);
        setServiceModeSelected(null);
        setLocationModeSelected(null);
        setGeoLocData(null);
        setRangeOptionSelected(null);
        setSelectServiceProviderCheckbox(false);
        setServiceProviderList([]);
        setServiceProviderListToShow([]);
        setBaseCityListToShow([]);
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setDateSelected(null);
        setSlotList([]);
        setSlotSelected(null);
        setStateList([]);
        setStateSelected(null);
        setCityList([]);
        setCitySelected(null);
        setLocalityList([]);
        setLocalitySelected(null);
        setAddressList([]);
        setAddressSelected(null);
        setLanguageSelected([]);
        setLanguages([]);
        setBaseCitySelected(null);
        setLoading(false);
        break;

      case 6: // after mode change
        setLocationModeSelected(null);
        setGeoLocData(null);
        setRangeOptionSelected(null);
        setAddressNotServiceableForPriorityVendors(false);
        setSelectServiceProviderCheckbox(false);
        setServiceProviderList([]);
        setServiceProviderListToShow([]);
        setBaseCityListToShow([]);
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setDateSelected(null);
        setSlotList([]);
        setSlotSelected(null);
        setStateList([]);
        setStateSelected(null);
        setCityList([]);
        setCitySelected(null);
        setLocalityList([]);
        setLocalitySelected(null);
        setAddressList([]);
        setAddressSelected(null);
        setLanguageSelected([]);
        setLanguages([]);
        setBaseCitySelected(null);
        setLoading(false);
        break;

      case 7: // after service provider change
        setDateSelected(null);
        setSlotList([]);
        setSlotSelected(null);
        setLoading(false);
        break;

      case 8: // after manual location change
        setSelectServiceProviderCheckbox(false);
        setServiceProviderAutoSelected(null);
        setServiceProviderSelected(null);
        setDateSelected(null);
        setSlotList([]);
        setSlotSelected(null);
        setLoading(false);
        break;

      case 9: // after booking for change
        setServiceListToShow([]);
        setServiceSelected(null);
        setServiceModeList([]);
        setServiceModeSelected(null);
        setLocationModeSelected(null);
        setGeoLocData(null);
        setRangeOptionSelected(null);
        setSelectServiceProviderCheckbox(false);
        setServiceProviderList([]);
        setServiceProviderListToShow([]);
        setBaseCityListToShow([]);
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setDateSelected(null);
        setSlotList([]);
        setSlotSelected(null);
        setStateList([]);
        setStateSelected(null);
        setCityList([]);
        setCitySelected(null);
        setLocalityList([]);
        setLocalitySelected(null);
        setAddressList([]);
        setAddressSelected(null);
        setLanguageSelected([]);
        setLanguages([]);
        setBaseCitySelected(null);
        setLoading(false);
        break;

      case 10: // after location mode change
        setGeoLocData(null);
        setRangeOptionSelected(null);
        setSelectServiceProviderCheckbox(false);
        setServiceProviderList([]);
        setServiceProviderListToShow([]);
        setBaseCityListToShow([]);
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setDateSelected(null);
        setSlotList([]);
        setSlotSelected(null);
        setStateSelected(null);
        setCityList([]);
        setCitySelected(null);
        setLocalityList([]);
        setLocalitySelected(null);
        setAddressList([]);
        setAddressSelected(null);
        setLanguageSelected([]);
        setLanguages([]);
        setBaseCitySelected(null);
        setLoading(false);
        break;

      case 11: // after location address change
        setRangeOptionSelected(null);
        setSelectServiceProviderCheckbox(false);
        setServiceProviderList([]);
        setServiceProviderListToShow([]);
        setBaseCityListToShow([]);
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setDateSelected(null);
        setSlotList([]);
        setSlotSelected(null);
        setStateSelected(null);
        setCityList([]);
        setCitySelected(null);
        setLocalityList([]);
        setLocalitySelected(null);
        setLanguageSelected([]);
        setBaseCitySelected(null);
        setLoading(false);
        break;

      case 12: // after radius change
        setSelectServiceProviderCheckbox(false);
        setServiceProviderList([]);
        setServiceProviderListToShow([]);
        setBaseCityListToShow([]);
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setDateSelected(null);
        setSlotList([]);
        setSlotSelected(null);
        setStateSelected(null);
        setCityList([]);
        setCitySelected(null);
        setLocalityList([]);
        setLocalitySelected(null);
        setLanguageSelected([]);
        setBaseCitySelected(null);
        setLoading(false);
        break;

      default:
        setCheckAddressServiceableResponse(null);
        setTotalModes([]);
        setPatientIdList([]);
        setPatientDetails(null);
        setAccountList([]);
        setAccountSelected(null);
        setPlanList([]);
        setPlanSelected(null);
        setServiceTypeList([]);
        setServiceTypeSelected(null);
        setServiceList([]);
        setServiceListToShow([]);
        setServiceSelected(null);
        setServiceModeList([]);
        setServiceModeSelected(null);
        setLocationModeSelected(null);
        setGeoLocData(null);
        setRangeOptionSelected(null);
        setSelectServiceProviderCheckbox(false);
        setServiceProviderList([]);
        setServiceProviderListToShow([]);
        setBaseCityListToShow([]);
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setFamilyMemberList([]);
        setSelectedFamilyMember(null);
        setRelationsList([]);
        setDateSelected(null);
        setSlotList([]);
        setSlotSelected(null);
        setPatientContactNumber(null);
        setPatientContactNumberCheckbox(false);
        setReasonList([]);
        setReasonSelected(null);
        setReasonDesc("");
        setStateList([]);
        setStateSelected(null);
        setCityList([]);
        setCitySelected(null);
        setLocalityList([]);
        setLocalitySelected(null);
        setAddressList([]);
        setAddressSelected(null);
        setPrice(null);
        setBaseCitySelected(null);
        setLoading(false);
        break;
    }
  };

  return (
    <div className="navigo-module-page-padding">
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="navigo-module-view">
            <div className="navigo-module-heading-with-back-button">
              <div
                className="navigo-module-back-btn"
                onClick={() => {
                  exitPage();
                }}
              >
                <FontIcon
                  id="back_button"
                  style={{ fontSize: "36px", marginTop: "2px" }}
                >
                  arrow_back
                </FontIcon>
              </div>
              <h1>{`Create appointment`}</h1>
            </div>
            <div className="navigo-module-buttons-container">
              <div className="navigo-module-buttons-right-alignment">
                <Button
                  id="cancel_cta"
                  raised
                  disabled={loading}
                  className="navigo-module-button-cancel"
                  onClick={() => {
                    exitPage();
                  }}
                >
                  {"Cancel"}
                </Button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <br />
      <br />
      {props?.data?.from === "SLOT_RESTRICTION_DASHBOARD" && (
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <TopNote
              text="Note:  Appointment created from here can be booked with reserved slots i.e Level 2 (SP assigned on service)"
              color="#DDF6EB"
              borderColor="#1BC47D"
            />
          </Col>
        </Row>
      )}
      <br />
      <div className="navigo-module-create-service-container">
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Patient ID`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div>
                <Autocomplete
                  style={{ top: "2px" }}
                  id="appointment_patient_id"
                  options={patientIdList}
                  value={patientDetails}
                  onChange={(e, v) => {
                    // Behaviourally identical to what was inlined here: the
                    // if-branch is selectPatient, extracted so the URL seed
                    // runs the very same fork. The field has no
                    // disableClearable, so the clear button arrives here as
                    // onChange(e, null) -> resetValues(1) ("after patient id
                    // change", 2178), which is how an operator overrides a
                    // seeded patient.
                    patientTouchedRef.current = true;
                    if (v) {
                      selectPatient(v);
                    } else {
                      resetValues(1);
                    }
                  }}
                  getOptionLabel={(option) =>
                    patientDetails
                      ? `${option.id}`
                      : `(${option.id}) ${option.firstName} ${option.lastName}`
                  }
                  filterOptions={(x) => x}
                  onInputChange={(e, value, reason) => {
                    // "input" is a keystroke; MUI also fires this with "reset"
                    // when the value changes programmatically, which is what
                    // the seed itself causes and must not be mistaken for the
                    // operator typing.
                    if (reason === "input") patientTouchedRef.current = true;
                    if (!patientDetails && /^\d*$/.test(value)) {
                      handlePidSearch(e, value, reason);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField2
                      {...params}
                      placeholder="Type here"
                      inputProps={{
                        ...params.inputProps,
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        readOnly: !!patientDetails,
                        onKeyPress: (e) => {
                          if (patientDetails) {
                            e.preventDefault();
                          } else if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        style: {
                          fontFamily: "Montserrat, sans-serif",
                          marginTop: "8px",
                        },
                        classes: {
                          underline: "custom-underline",
                        },
                      }}
                    />
                  )}
                />
              </div>
            </div>
          </Col>
        </Row>

        <br />
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Patient name`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div>
                <TextField
                  value={
                    patientDetails
                      ? `${patientDetails.firstName} ${patientDetails.lastName}`
                      : ""
                  }
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Patient number`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div>
                <div style={{ display: "flex" }}>
                  <div style={{ width: "40px", marginRight: "20px" }}>
                    <TextField
                      value={
                        patientDetails ? `+${patientDetails.countryCode}` : ""
                      }
                      lineDirection="left"
                      disabled
                    />
                  </div>
                  <div style={{ flex: "1" }}>
                    <TextField
                      value={patientDetails ? `${patientDetails.phoneno}` : ""}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Patient current age`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div>
                <TextField
                  value={
                    patientDetails
                      ? `${getAgeFromDob(patientDetails?.dateOfBirth)}`
                      : ""
                  }
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
        </Row>

        <br />
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Date of birth`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div>
                <TextField
                  value={
                    patientDetails
                      ? `${moment(patientDetails.dateOfBirth).format(
                          "DD MMM YYYY",
                        )}`
                      : ""
                  }
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Email ID`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div>
                <TextField
                  value={
                    patientDetails
                      ? `${patientDetails.email ? patientDetails.email : ""}`
                      : ""
                  }
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Gender`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div>
                <TextField
                  value={
                    patientDetails
                      ? `${
                          patientDetails.gender === 1
                            ? "Female"
                            : patientDetails.gender === 2
                              ? "Male"
                              : patientDetails.gender === 0
                                ? "XXXXXXX"
                                : ""
                        }`
                      : ""
                  }
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
        </Row>

        <br />
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Select account`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div>
                <Autocomplete
                  id="account_drop_down"
                  options={accountList}
                  value={accountSelected}
                  disabled={loading}
                  onChange={(e, v) => {
                    if (v) {
                      if (accountSelected != null) {
                        resetValues(2);
                      }
                      setAccountSelected(v);
                    } else {
                      setAccountSelected(null);
                      resetValues(2);
                    }
                  }}
                  getOptionLabel={(option) => option || ""}
                  filterOptions={(x) => x}
                  renderInput={(params) => (
                    <TextField2
                      {...params}
                      placeholder="Select"
                      InputProps={{
                        ...params.InputProps,
                        style: {
                          fontFamily: "Montserrat, sans-serif",
                          marginTop: "8px",
                        },
                        classes: {
                          underline: "custom-underline",
                        },
                      }}
                    />
                  )}
                />
              </div>
            </div>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Select plan`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div>
                <Autocomplete
                  id="plan_drop_down"
                  options={planList}
                  value={planSelected}
                  disabled={loading}
                  onChange={(e, v) => {
                    if (v) {
                      if (planSelected != null) {
                        resetValues(3);
                      }
                      setPlanSelected(v);
                    } else {
                      setPlanSelected(null);

                      resetValues(3);
                    }
                  }}
                  getOptionLabel={(option) =>
                    option ? `(${option.planId}) ${option.name}` : ""
                  }
                  filterOptions={(options, { inputValue }) => {
                    const searchText = inputValue.toLowerCase();

                    return options.filter((option) => {
                      const planName = option.name.toLowerCase();
                      const planId = option.planId.toString();

                      return (
                        planName.includes(searchText) ||
                        planId.includes(searchText)
                      );
                    });
                  }}
                  renderInput={(params) => (
                    <TextField2
                      {...params}
                      placeholder="Select"
                      InputProps={{
                        ...params.InputProps,
                        style: {
                          fontFamily: "Montserrat, sans-serif",
                          marginTop: "8px",
                        },
                        classes: {
                          underline: "custom-underline",
                        },
                      }}
                    />
                  )}
                />
              </div>
            </div>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Select service type`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div>
                <Autocomplete
                  id="mp-navigo-service-type-selection"
                  options={serviceTypeList}
                  value={serviceTypeSelected}
                  disabled={loading}
                  onChange={(e, v) => {
                    if (v) {
                      if (serviceTypeSelected != null) {
                        resetValues(4);
                      }
                      setServiceTypeSelected(v);
                    } else {
                      setServiceTypeSelected(null);

                      resetValues(4);
                    }
                  }}
                  getOptionLabel={(option) =>
                    option ? option.serviceTypeName : ""
                  }
                  filterOptions={(options, { inputValue }) => {
                    const searchText = inputValue.toLowerCase();

                    return options.filter((option) => {
                      const serviceTypeName =
                        option.serviceTypeName?.toLowerCase() || "";

                      return serviceTypeName.includes(searchText);
                    });
                  }}
                  renderInput={(params) => (
                    <TextField2
                      {...params}
                      placeholder="Select"
                      InputProps={{
                        ...params.InputProps,
                        style: {
                          fontFamily: "Montserrat, sans-serif",
                          marginTop: "8px",
                        },
                        classes: {
                          underline: "custom-underline",
                        },
                      }}
                    />
                  )}
                />
              </div>
            </div>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} sm={5} md={5} lg={5}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Booking for`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div>
                <Autocomplete
                  id="service_type_dropdown"
                  options={familyMemberList}
                  disabled={loading || serviceTypeSelected == null}
                  value={selectedFamilyMember}
                  onChange={(e, v) => {
                    if (v) {
                      if (selectedFamilyMember != null) {
                        resetValues(9);
                      }
                      setSelectedFamilyMember(v);
                    } else {
                      setSelectedFamilyMember(null);
                      resetValues(9);
                    }
                  }}
                  getOptionLabel={(option) =>
                    option
                      ? `(${option.memberPatientId}) ${option.firstName} ${
                          option.lastName
                        } (${
                          option?.gender === 1
                            ? "F"
                            : option?.gender === 2
                              ? "M"
                              : "-"
                        }/${option?.dateOfBirth}/${
                          relationsList.find((e) => e.code === option.relation)
                            .value
                        })`
                      : ""
                  }
                  filterOptions={(options, { inputValue }) => {
                    const searchText = inputValue.toLowerCase();

                    return options.filter((option) => {
                      const memberPatientId =
                        option.memberPatientId?.toString() || "";
                      const firstName = option.firstName?.toLowerCase() || "";
                      const lastName = option.lastName?.toLowerCase() || "";
                      const relationValue =
                        relationsList
                          .find((e) => e.code === option.relation)
                          ?.value?.toLowerCase() || "";

                      return (
                        memberPatientId.includes(searchText) ||
                        firstName.includes(searchText) ||
                        lastName.includes(searchText) ||
                        relationValue.includes(searchText)
                      );
                    });
                  }}
                  renderInput={(params) => (
                    <TextField2
                      {...params}
                      placeholder="Select"
                      InputProps={{
                        ...params.InputProps,
                        style: {
                          fontFamily: "Montserrat, sans-serif",
                          marginTop: "8px",
                        },
                        classes: {
                          underline: "custom-underline",
                        },
                      }}
                    />
                  )}
                />
              </div>
            </div>
          </Col>
        </Row>
        <br />

        {serviceTypeSelected != null &&
        serviceTypeSelected.serviceTypeId == SERVICE_TYPE.CONSULTATION ? (
          <div>
            <Row>
              <Col xs={12} sm={11} md={11} lg={11}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    {`Select service code/name`}
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div>
                    <Autocomplete
                      id="service_code_name_dropdown"
                      options={serviceListToShow}
                      disabled={loading || selectedFamilyMember == null}
                      value={serviceSelected}
                      onChange={(e, v) => {
                        if (v) {
                          if (serviceSelected != null) {
                            resetValues(5);
                          }
                          setServiceSelected(v);
                        } else {
                          setServiceSelected(null);
                          resetValues(5);
                        }
                      }}
                      getOptionLabel={(option) => {
                        if (!option) return "";
                        const serviceId = option.serviceId ?? "";
                        const serviceCode = option.serviceCode ?? "";
                        const modes =
                          option.serviceModeDetails
                            ?.map((m) => m.modeName)
                            .join(" / ") ?? "";
                        const name = option.name ?? "";
                        let priceText = "";
                        if (
                          Array.isArray(option.serviceModeDetails) &&
                          option.serviceModeDetails.length > 0
                        ) {
                          const price =
                            option.serviceModeDetails[0]?.discountedPrice;
                          if (option.serviceModeDetails.length === 1) {
                            priceText =
                              price !== undefined && price !== null
                                ? ` (at Rs. ${price})`
                                : "";
                          } else {
                            priceText =
                              price !== undefined && price !== null
                                ? ` (starting from Rs. ${price})`
                                : "";
                          }
                        }
                        return `(${serviceId}) ${serviceCode} / ${name} (${modes})${priceText}`;
                      }}
                      filterOptions={(options, { inputValue }) => {
                        const searchText = inputValue.toLowerCase();

                        return options.filter((option) => {
                          const serviceId = String(option.serviceId ?? "");
                          const serviceCode =
                            option.serviceCode?.toLowerCase() ?? "";
                          const name = option.name?.toLowerCase() ?? "";
                          const modes =
                            option.serviceModeDetails
                              ?.map((m) => m.modeName.toLowerCase())
                              .join(" / ") ?? "";

                          return (
                            serviceId.includes(searchText) ||
                            serviceCode.includes(searchText) ||
                            name.includes(searchText) ||
                            modes.includes(searchText)
                          );
                        });
                      }}
                      renderInput={(params) => (
                        <TextField2
                          {...params}
                          placeholder="Select"
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              fontFamily: "Montserrat, sans-serif",
                              marginTop: "8px",
                            },
                            classes: {
                              underline: "custom-underline",
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs={12} sm={5} md={5} lg={5}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    {`Select service mode`}
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div>
                    <Autocomplete
                      id="service_mode"
                      options={serviceModeList}
                      disabled={loading || serviceSelected == null}
                      value={serviceModeSelected}
                      onChange={(e, v) => {
                        if (v) {
                          if (serviceModeSelected != null) {
                            resetValues(6);
                          }

                          setServiceModeSelected(v);
                        } else {
                          setServiceModeSelected(null);

                          resetValues(6);
                        }
                      }}
                      getOptionLabel={(option) => {
                        if (!option) return "";
                        const modeDetail =
                          serviceSelected?.serviceModeDetails?.find(
                            (m) => m.modeName === option,
                          );

                        if (!modeDetail) return option;

                        if (modeDetail.hasDifferentialPricing) {
                          return `${option} (price varies on service provider)`;
                        } else {
                          return `${option} (Rs ${modeDetail.discountedPrice})`;
                        }
                      }}
                      filterOptions={(options, { inputValue }) => {
                        const searchText = inputValue.toLowerCase();

                        return options.filter((option) => {
                          const serviceMode = option.toLowerCase() || "";

                          return serviceMode.includes(searchText);
                        });
                      }}
                      renderInput={(params) => (
                        <TextField2
                          {...params}
                          placeholder="Select"
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              fontFamily: "Montserrat, sans-serif",
                              marginTop: "8px",
                            },
                            classes: {
                              underline: "custom-underline",
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            {serviceModeSelected === MODES.IN_PERSON_CONSULTATION && (
              <>
                <br />
                <Row>
                  <Col xs={12} sm={3} md={3} lg={3}>
                    <div className="navigo-module-create-service-field-container">
                      <div className="navigo-module-label">
                        {`Select location mode`}
                        <label className="navigo-module-label-red"> *</label>
                      </div>
                      <div>
                        <Autocomplete
                          id="location_dropdown"
                          options={SELECT_LOCATION_MODE_OPTIONS}
                          getOptionLabel={(option) => option.label}
                          value={locationModeSelected}
                          disabled={loading}
                          isOptionEqualToValue={(option, value) =>
                            option.value === value?.value
                          }
                          onChange={(e, v) => {
                            if (v) {
                              setLocationModeSelected(v);
                            } else {
                              setLocationModeSelected(null);
                            }
                            resetValues(10);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              placeholder="Select"
                              InputProps={{
                                ...params.InputProps,
                                style: {
                                  fontFamily: "Montserrat, sans-serif",
                                  marginTop: "8px",
                                },
                                classes: {
                                  underline: "custom-underline",
                                },
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  {locationModeSelected?.value == LOCATION_MODE.GOOGLE_MAPS && (
                    <>
                      <Col xs={12} sm={1} md={1} lg={1}>
                        <div style={{ height: "20px" }}></div>
                      </Col>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div style={{ marginTop: "14px", width: "175px" }}>
                          <Button
                            id="location_button"
                            className={
                              !geoLocData?.latLng
                                ? "zy-btn-blue-1"
                                : "zy-btn-orange-1"
                            }
                            onClick={() => {
                              handleOpenLocationPicker();
                            }}
                          >
                            {!geoLocData?.latLng
                              ? "Choose location"
                              : "Change location"}
                          </Button>
                        </div>
                      </Col>
                    </>
                  )}
                </Row>

                {locationModeSelected?.value == LOCATION_MODE.GOOGLE_MAPS &&
                  geoLocData?.latLng !== null && (
                    <>
                      <br />
                      <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div className="navigo-module-create-service-field-container">
                            <div className="navigo-module-label">
                              {`Location`}
                            </div>
                            <div>
                              <TextField
                                id="location"
                                value={formatAddress(geoLocData?.address) ?? ""}
                                lineDirection="left"
                                disabled
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}

                {locationModeSelected?.value == LOCATION_MODE.MANUAL && (
                  <>
                    <br />
                    <Row>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            {`Select state`}
                            <label className="navigo-module-label-red">
                              {" "}
                              *
                            </label>
                          </div>
                          <div>
                            <Autocomplete
                              id="select_state"
                              options={stateList}
                              disabled={loading}
                              value={stateSelected}
                              onChange={(e, v) => {
                                if (v) {
                                  if (stateSelected != null) {
                                    resetValues(8);
                                    setCityList([]);
                                    setCitySelected(null);
                                    setLocalityList([]);
                                    setLocalitySelected(null);
                                    getLanguages(v, null, null);
                                  }
                                  getSPByFilters(v, null, null);
                                  setStateSelected(v);
                                  getLanguages(v, null, null);
                                } else {
                                  setStateSelected(null);

                                  resetValues(8);
                                  setCityList([]);
                                  setCitySelected(null);
                                  setLocalityList([]);
                                  setLocalitySelected(null);
                                  // getProviderOfPlanService(serviceModeSelected);
                                  getSPByFilters(null, null, null);
                                  getLanguages(null, null, null);
                                }
                              }}
                              getOptionLabel={(option) =>
                                option ? option : ""
                              }
                              filterOptions={(options, { inputValue }) => {
                                const searchText = inputValue.toLowerCase();

                                return options.filter((option) => {
                                  const state = option.toLowerCase() || "";

                                  return state.includes(searchText);
                                });
                              }}
                              renderInput={(params) => (
                                <TextField2
                                  {...params}
                                  placeholder="Select"
                                  InputProps={{
                                    ...params.InputProps,
                                    style: {
                                      fontFamily: "Montserrat, sans-serif",
                                      marginTop: "8px",
                                    },
                                    classes: {
                                      underline: "custom-underline",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={1} md={1} lg={1}>
                        <div style={{ height: "20px" }}></div>
                      </Col>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            {`Select city`}
                            <label className="navigo-module-label-red">
                              {" "}
                              *
                            </label>
                          </div>
                          <div>
                            <Autocomplete
                              id="select_city"
                              options={cityList}
                              disabled={loading || stateSelected === null}
                              value={citySelected}
                              onChange={(e, v) => {
                                if (v) {
                                  if (citySelected != null) {
                                    resetValues(8);
                                    setLocalityList([]);
                                    setLocalitySelected(null);
                                    getLanguages(stateSelected, v, null);
                                  }

                                  setCitySelected(v);
                                  getLanguages(stateSelected, v, null);
                                } else {
                                  setCitySelected(null);

                                  resetValues(8);
                                  getSPByFilters(stateSelected, null, null);
                                  setLocalityList([]);
                                  setLocalitySelected(null);
                                  getLanguages(stateSelected, null, null);
                                }
                              }}
                              getOptionLabel={(option) =>
                                option ? option : ""
                              }
                              filterOptions={(options, { inputValue }) => {
                                const searchText = inputValue.toLowerCase();

                                return options.filter((option) => {
                                  const city = option.toLowerCase() || "";

                                  return city.includes(searchText);
                                });
                              }}
                              renderInput={(params) => (
                                <TextField2
                                  {...params}
                                  placeholder="Select"
                                  InputProps={{
                                    ...params.InputProps,
                                    style: {
                                      fontFamily: "Montserrat, sans-serif",
                                      marginTop: "8px",
                                    },
                                    classes: {
                                      underline: "custom-underline",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={1} md={1} lg={1}>
                        <div style={{ height: "20px" }}></div>
                      </Col>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">{`Select locality`}</div>
                          <div>
                            <Autocomplete
                              id="select_locality"
                              options={localityList}
                              disabled={loading || citySelected === null}
                              value={localitySelected}
                              onChange={(e, v) => {
                                if (v) {
                                  if (localitySelected != null) {
                                    getLanguages(
                                      stateSelected,
                                      citySelected,
                                      v,
                                    );
                                  }
                                  resetValues(8);
                                  getSPByFilters(
                                    stateSelected,
                                    citySelected,
                                    v,
                                  );
                                  setLocalitySelected(v);
                                  getLanguages(stateSelected, citySelected, v);
                                } else {
                                  setLocalitySelected(null);

                                  resetValues(8);
                                  getSPByFilters(
                                    stateSelected,
                                    citySelected,
                                    null,
                                  );
                                  getLanguages(
                                    stateSelected,
                                    citySelected,
                                    null,
                                  );
                                }
                              }}
                              getOptionLabel={(option) =>
                                option ? option : ""
                              }
                              filterOptions={(options, { inputValue }) => {
                                const searchText = inputValue.toLowerCase();

                                return options.filter((option) => {
                                  const locality = option.toLowerCase() || "";

                                  return locality.includes(searchText);
                                });
                              }}
                              renderInput={(params) => (
                                <TextField2
                                  {...params}
                                  placeholder="Select"
                                  InputProps={{
                                    ...params.InputProps,
                                    style: {
                                      fontFamily: "Montserrat, sans-serif",
                                      marginTop: "8px",
                                    },
                                    classes: {
                                      underline: "custom-underline",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
                {locationModeSelected?.value ==
                  LOCATION_MODE.SAVED_ADDRESSES && (
                  <>
                    <br />
                    <Row>
                      <Col xs={12} sm={5} md={5} lg={5}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            {`Select address`}
                            <label className="navigo-module-label-red">
                              {" "}
                              *
                            </label>
                          </div>
                          <div>
                            <Autocomplete
                              id="select_address"
                              options={addressList}
                              value={addressSelected}
                              disabled={loading || serviceModeSelected == null}
                              onOpen={() => {
                                getPatientAddress();
                              }}
                              onChange={(e, v) => {
                                resetValues(11);
                                if (v) {
                                  setLoading(true);
                                  getLocationFromSavedAddress(v);
                                } else {
                                  setAddressSelected(null);
                                }
                              }}
                              getOptionLabel={(option) =>
                                option
                                  ? `${option.line1}, ${option.line2}, ${
                                      option.landmark && option.landmark != ""
                                        ? `${option.landmark}, `
                                        : ""
                                    }${option.city}, ${option.district}, ${
                                      option.state
                                    } - ${option.pincode}`
                                  : ""
                              }
                              filterOptions={(options, { inputValue }) => {
                                const searchText = inputValue.toLowerCase();

                                return options.filter((option) => {
                                  const addressString = [
                                    option.line1,
                                    option.line2,
                                    option.landmark,
                                    option.city,
                                    option.district,
                                    option.state,
                                    option.pincode,
                                  ]
                                    .filter(Boolean)
                                    .join(", ")
                                    .toLowerCase();

                                  return addressString.includes(searchText);
                                });
                              }}
                              renderInput={(params) => (
                                <TextField2
                                  {...params}
                                  placeholder="Select"
                                  InputProps={{
                                    ...params.InputProps,
                                    style: {
                                      fontFamily: "Montserrat, sans-serif",
                                      marginTop: "8px",
                                    },
                                    classes: {
                                      underline: "custom-underline",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )}

            <br />
            <Row>
              {(locationModeSelected?.value == LOCATION_MODE.GOOGLE_MAPS ||
                locationModeSelected?.value == LOCATION_MODE.SAVED_ADDRESSES) &&
                geoLocData?.latLng !== null && (
                  <>
                    <Col xs={12} sm={3} md={3} lg={3}>
                      <div className="navigo-module-create-service-field-container">
                        <div className="navigo-module-label">
                          {`Area radius`}
                          <label className="navigo-module-label-red"> *</label>
                        </div>
                        <div>
                          <Autocomplete
                            id="area_radius"
                            options={LOCATION_RANGE_KMS_OPTIONS}
                            value={rangeOptionSelected}
                            disabled={
                              loading ||
                              geoLocData?.latLng == null ||
                              (addressSelected == null &&
                                locationModeSelected?.value ==
                                  LOCATION_MODE.SAVED_ADDRESSES)
                            }
                            getOptionLabel={(option) => option?.label ?? ""}
                            isOptionEqualToValue={(option, value) =>
                              option?.value === value?.value
                            }
                            onChange={(e, v) => {
                              resetValues(12);
                              handleRadiusKmSelected(
                                v,
                                false,
                                geoLocData?.latLng,
                              );
                            }}
                            renderInput={(params) => (
                              <TextField2
                                {...params}
                                placeholder="Select"
                                InputProps={{
                                  ...params.InputProps,
                                  style: {
                                    fontFamily: "Montserrat, sans-serif",
                                    marginTop: "8px",
                                  },
                                  classes: {
                                    underline: "custom-underline",
                                  },
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} sm={1} md={1} lg={1}>
                      <div style={{ height: "20px" }}></div>
                    </Col>
                  </>
                )}

              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    {`Preferred language`}
                    {/* <label className="navigo-module-label-red"> *</label> */}
                  </div>
                  <div>
                    <Autocomplete
                      id="language_dropdown"
                      options={languages}
                      disabled={
                        loading ||
                        serviceModeSelected == null ||
                        (serviceTypeSelected.serviceTypeId ==
                          SERVICE_TYPE.CONSULTATION &&
                          serviceModeSelected ===
                            MODES.IN_PERSON_CONSULTATION &&
                          citySelected === null &&
                          !rangeOptionSelected)
                      }
                      value={languageSelected}
                      multiple
                      onChange={(e, v) => {
                        if (v.length > 0) {
                          setLanguageSelected(v);
                        } else {
                          setLanguageSelected([]);
                          if (
                            locationModeSelected?.value ==
                              LOCATION_MODE.GOOGLE_MAPS ||
                            locationModeSelected?.value ==
                              LOCATION_MODE.SAVED_ADDRESSES
                          ) {
                            getSPByFilters(null, null, null, [], {
                              latLng: geoLocData?.latLng,
                              radius: rangeOptionSelected?.value,
                              autocheck: false,
                            });
                          } else {
                            getSPByFilters(
                              stateSelected,
                              citySelected,
                              localitySelected,
                            );
                          }

                          resetValues(8);
                        }
                      }}
                      getOptionLabel={(option) => (option ? option : "")}
                      filterOptions={(options, { inputValue }) => {
                        const searchText = inputValue.toLowerCase();

                        return options.filter((option) => {
                          const lang = option.toLowerCase() || "";

                          return lang.includes(searchText);
                        });
                      }}
                      renderInput={(params) => (
                        <TextField2
                          {...params}
                          placeholder="Select"
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              fontFamily: "Montserrat, sans-serif",
                              marginTop: "8px",
                            },
                            classes: {
                              underline: "custom-underline",
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs={12} sm={11} md={11} lg={11}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div>
                    <Checkbox
                      id="mode_checkbox"
                      name="mp-appointment-checkbox-1"
                      style={{ marginLeft: -13, marginTop: 3 }}
                      disabled={
                        !isAutoSPAllowed(serviceModeSelected) ||
                        loading ||
                        serviceModeSelected == null ||
                        (serviceModeSelected === MODES.IN_PERSON_CONSULTATION &&
                          citySelected == null &&
                          !rangeOptionSelected)
                      }
                      // color={mode == 2 ? "default" : "secondary"}
                      checked={selectServiceProviderCheckbox}
                      onChange={(value, proxy) => {
                        setDateSelected(null);
                        setSlotSelected(null);
                        setSlotList([]);
                        setServiceProviderSelected(null);
                        setServiceProviderAutoSelected(null);
                        if (selectServiceProviderCheckbox) {
                          setSelectServiceProviderCheckbox(false);
                        } else {
                          setSelectServiceProviderCheckbox(true);
                        }
                      }}
                    />
                  </div>
                  <div className="navigo-module-label-checkbox">
                    {`Select service provider or check mark to select automatically`}{" "}
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                </div>

                <div
                  className="navigo-module-checkbox-field-container"
                  style={{ marginTop: "-16px" }}
                >
                  <div>
                    <Autocomplete
                      id="select_service_provider"
                      options={serviceProviderListToShow}
                      value={serviceProviderSelected}
                      disabled={
                        selectServiceProviderCheckbox ||
                        loading ||
                        serviceModeSelected == null ||
                        (serviceModeSelected === MODES.IN_PERSON_CONSULTATION &&
                          citySelected == null &&
                          !rangeOptionSelected)
                      }
                      onChange={(e, v) => {
                        if (v) {
                          if (serviceProviderSelected != null) {
                            resetValues(7);
                          }
                          setServiceProviderSelected(v);
                        } else {
                          setServiceProviderSelected(null);

                          resetValues(7);
                        }
                      }}
                      getOptionLabel={(option) =>
                        getSPLabelTypeConsult(option, serviceModeSelected)
                      }
                      filterOptions={
                        serviceModeSelected === MODES.IN_PERSON_CONSULTATION
                          ? (options, { inputValue }) => {
                              const searchText = inputValue.toLowerCase();
                              return options.filter((option) => {
                                const label = `(${
                                  option.vendorDoctorId &&
                                  option.vendorDoctorId !== 0
                                    ? option.vendorDoctorId
                                    : option.id
                                }) ${option.name} - ${
                                  option?.address?.city ?? ""
                                } - ${
                                  option?.address?.landmark ?? ""
                                }`.toLowerCase();
                                return label.includes(searchText);
                              });
                            }
                          : (options, { inputValue }) => {
                              const searchText = inputValue.toLowerCase();
                              return options.filter((option) => {
                                const label =
                                  `(${option.id}) ${option.name}`.toLowerCase();
                                return label.includes(searchText);
                              });
                            }
                      }
                      renderOption={(option, state) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {option?.margin?.colour ? (
                            <span
                              style={{
                                width: 12,
                                height: 12,
                                borderRadius: "50%",
                                backgroundColor: option.margin.colour,
                                marginRight: 8,
                              }}
                            />
                          ) : null}

                          {getSPLabelTypeConsult(option, serviceModeSelected)}
                        </div>
                      )}
                      renderInput={(params) => (
                        <TextField2
                          {...params}
                          multiline
                          placeholder="Select"
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: serviceProviderSelected?.margin
                              ?.colour ? (
                              <span
                                style={{
                                  width: 12,
                                  height: 12,
                                  borderRadius: "50%",
                                  backgroundColor:
                                    serviceProviderSelected.margin.colour,
                                  marginRight: 8,
                                  marginLeft: 4,
                                }}
                              />
                            ) : null,

                            style: {
                              fontFamily: "Montserrat, sans-serif",
                              marginTop: "8px",
                            },
                            classes: {
                              underline: "custom-underline",
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </Col>
              {(locationModeSelected?.value == LOCATION_MODE.GOOGLE_MAPS ||
                locationModeSelected?.value == LOCATION_MODE.SAVED_ADDRESSES) &&
                serviceProviderSelected && (
                  <>
                    <Col xs={12} sm={3} md={3} lg={3}>
                      <div
                        className="navigo-module-create-service-field-container"
                        style={{ marginTop: "14px" }}
                      >
                        <div className="navigo-module-label">
                          {`Distance from location provider`}
                        </div>
                        <div>
                          <TextField
                            id="distance"
                            value={formatDistanceKm(
                              serviceProviderSelected?.distanceFromSource,
                            )}
                            lineDirection="left"
                            disabled
                          />
                        </div>
                      </div>
                    </Col>
                  </>
                )}

              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>

              {Boolean(
                serviceModeSelected === MODES.IN_PERSON_CONSULTATION &&
                (serviceProviderSelected?.addresses ?? []).length > 0,
              ) && (
                <Col xs={12} sm={5} md={5} lg={5}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div className="navigo-module-label-checkbox">
                      {`Select clinic address`}{" "}
                      <label className="navigo-module-label-red"> *</label>
                    </div>
                  </div>

                  <div className="navigo-module-checkbox-field-container">
                    <div>
                      <Autocomplete
                        id="clinic_address"
                        options={serviceProviderSelected?.addresses ?? []}
                        value={serviceProviderSelected?.address}
                        disabled={
                          loading ||
                          serviceModeSelected == null ||
                          (serviceModeSelected ===
                            MODES.IN_PERSON_CONSULTATION &&
                            citySelected == null)
                        }
                        onChange={(e, v) => {
                          if (v) {
                            if (serviceProviderSelected != null) {
                              resetValues(7);
                            }
                            getSPByFilters(
                              stateSelected,
                              citySelected,
                              localitySelected,
                              null,
                              null,
                              {
                                vendorDoctorId:
                                  serviceProviderSelected?.vendorDoctorId ?? 0,
                                vendorId:
                                  serviceProviderSelected?.vendorId ?? "",
                                vendorCode:
                                  serviceProviderSelected?.vendorCode ?? "",
                                providerAddressId: v?.providerAddressId ?? "",
                              },
                              (res) => {
                                // setServiceProviderList(providers);
                                // setServiceProviderListToShow(providers);
                                setServiceProviderSelected(res?.providers?.[0]);
                                setLoading(false);
                              },
                            );
                          } else {
                            // setServiceProviderSelected(null);
                            // resetValues(7);
                          }
                        }}
                        getOptionLabel={(option) =>
                          option ? `${option?.housing ?? "-"}` : "-"
                        }
                        filterOptions={(options, { inputValue }) => {
                          const searchText = inputValue.toLowerCase();
                          return options.filter((option) => {
                            const label = `${
                              option?.housing ?? "-"
                            }`.toLowerCase();
                            return label.includes(searchText);
                          });
                        }}
                        renderOption={(option, state) => (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {option ? `${option?.housing ?? "-"}` : "-"}
                          </div>
                        )}
                        renderInput={(params) => (
                          <TextField2
                            {...params}
                            placeholder="Select clinic address"
                            InputProps={{
                              ...params.InputProps,

                              style: {
                                fontFamily: "Montserrat, sans-serif",
                                marginTop: "8px",
                              },
                              classes: {
                                underline: "custom-underline",
                              },
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                </Col>
              )}
            </Row>
            {serviceProviderSelected &&
              serviceProviderSelected?.amenities?.breakfastAvailable ==
                true && (
                <>
                  <br />
                  <Row>
                    <div
                      id="breakfast_available"
                      className="navigo-module-create-service-field-container"
                      style={{ marginLeft: "6px" }}
                    >
                      <div className="navigo-module-label">{`Amenities`}</div>
                      <div className="navigo-module-info-badge">
                        {"Breakfast available"}
                      </div>
                    </div>
                  </Row>
                </>
              )}
            {serviceModeSelected === MODES.IN_PERSON_CONSULTATION && (
              <>
                <br />
                <Row>
                  <Col xs={12} sm={8} md={8} lg={8}>
                    <div className="navigo-module-create-service-field-container">
                      <div className="navigo-module-label">
                        {`Google map link`}
                      </div>
                      <div>
                        <TextField
                          id="google_map_link"
                          value={
                            serviceProviderSelected?.address?.googleMapLink ??
                            ""
                          }
                          lineDirection="left"
                          disabled
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </>
            )}
            <br />
            <Row>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    {`Choose date`}
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div style={{ paddingTop: "10px" }}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                        id="date_picker"
                        style={{ width: "100%" }}
                        value={dateSelected}
                        onChange={(date) => {
                          setDateSelected(date);
                        }}
                        onOpen={() => {
                          setDatePickerOpened(true);
                        }}
                        onClose={() => {
                          setDatePickerOpened(false);
                        }}
                        autoOk={true}
                        disabled={
                          loading ||
                          (serviceProviderSelected == null &&
                            selectServiceProviderCheckbox == false) ||
                          areDatesAvailable1(
                            selectServiceProviderCheckbox,
                            serviceProviderSelected,
                          ) === false
                        }
                        className="navigo-module-appointment-datepicker"
                        format="DD MMM YYYY"
                        placeholder="DD MMM YYYY"
                        keyboardIcon={<FontIcon>calendar_month</FontIcon>}
                        variant="inline"
                        minDate={getMinDate1(
                          selectServiceProviderCheckbox,
                          serviceProviderSelected,
                        )}
                        maxDate={getMaxDate1(
                          selectServiceProviderCheckbox,
                          serviceProviderSelected,
                        )}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    {`Choose timeslot`}
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div>
                    <Autocomplete
                      id="slot_selection"
                      value={slotSelected}
                      disabled={loading || dateSelected === null}
                      options={slotList}
                      onChange={(e, v) => {
                        if (v) {
                          setSlotSelected(v);
                        } else {
                          setSlotSelected(null);
                        }
                      }}
                      getOptionLabel={(option) =>
                        option ? intToTime12(option.value) : ""
                      }
                      renderInput={(params) => (
                        <TextField2
                          {...params}
                          placeholder="Choose timeslot"
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              fontFamily: "Montserrat, sans-serif",
                              marginTop: "8px",
                            },
                            classes: {
                              underline: "custom-underline",
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            {serviceModeSelected != MODES.IN_PERSON_CONSULTATION && (
              <>
                <br />
                <Row>
                  <Col xs={12} sm={3} md={3} lg={3}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <div>
                        <Checkbox
                          id="inperson_consulatation"
                          name="mp-appointment-checkbox-2"
                          style={{ marginLeft: -13, marginTop: 3 }}
                          // disabled={mode == 2}
                          // color={mode == 2 ? "default" : "secondary"}
                          checked={patientContactNumberCheckbox}
                          onChange={() => {
                            if (patientContactNumberCheckbox) {
                              setPatientContactNumberCheckbox(false);
                              setPatientContactNumber(patientDetails.phoneno);
                            } else {
                              setPatientContactNumberCheckbox(true);
                            }
                          }}
                        />
                      </div>
                      <div className="navigo-module-label-checkbox">
                        {`Patient contact number`}
                        <label className="navigo-module-label-red"> *</label>
                      </div>
                    </div>

                    <div
                      className="navigo-module-checkbox-field-container"
                      style={{ marginTop: "-16px" }}
                    >
                      <div>
                        <div style={{ display: "flex" }}>
                          <div style={{ width: "40px", marginRight: "20px" }}>
                            <TextField
                              value={
                                patientDetails
                                  ? `+${patientDetails.countryCode}`
                                  : ""
                              }
                              lineDirection="left"
                              disabled
                            />
                          </div>
                          <div style={{ flex: "1" }}>
                            <TextField
                              value={
                                patientContactNumber != null
                                  ? `${patientContactNumber}`
                                  : ""
                              }
                              lineDirection="left"
                              type="text"
                              disabled={!patientContactNumberCheckbox}
                              onChange={(e) => {
                                let value = e.replace(/\D/g, "");

                                if (value.length <= 10) {
                                  setPatientContactNumber(
                                    value === "" ? "" : Number(value),
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col xs={12} sm={3} md={3} lg={3}>
                    <div className="navigo-module-create-service-field-container">
                      <div className="navigo-module-label">
                        {`Reason for consultation`}
                        <label className="navigo-module-label-red"> *</label>
                      </div>
                      <div>
                        <Autocomplete
                          id="reason_for_consultation"
                          options={reasonList.filter((r) => r?.isActive)}
                          value={reasonSelected}
                          onChange={(e, v) => {
                            if (v) {
                              setReasonSelected(v);
                            } else {
                              setReasonSelected(null);
                            }
                          }}
                          getOptionLabel={(option) =>
                            option ? option.name : ""
                          }
                          filterOptions={(options, { inputValue }) => {
                            const searchText = inputValue.toLowerCase();

                            return options.filter((option) => {
                              const reason = option.name?.toLowerCase() || "";

                              return reason.includes(searchText);
                            });
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              placeholder="Select"
                              InputProps={{
                                ...params.InputProps,
                                style: {
                                  fontFamily: "Montserrat, sans-serif",
                                  marginTop: "8px",
                                },
                                classes: {
                                  underline: "custom-underline",
                                },
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <div className="navigo-module-create-service-field-container">
                      <div className="navigo-module-label">
                        {`Describe the reason (mandatory only if "other" is selected in Reason for consultation field)`}
                      </div>
                      <div>
                        <TextField
                          id="describe_the_reason"
                          value={reasonDesc}
                          lineDirection="left"
                          placeholder="Type here"
                          onChange={(e) => {
                            setReasonDesc(e);
                          }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </>
            )}
            {renderTotalAmountAndCreateAptBtn()}
          </div>
        ) : serviceTypeSelected != null &&
          (serviceTypeSelected.serviceTypeId == SERVICE_TYPE.HEALTH_CHECKUP ||
            serviceTypeSelected.serviceTypeId == SERVICE_TYPE.VACCINE ||
            serviceTypeSelected.serviceTypeId == SERVICE_TYPE.DENTAL) ? (
          <div>
            <Row>
              <Col xs={12} sm={11} md={11} lg={11}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    {`Select service code/name`}
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div>
                    <Autocomplete
                      id="mp-navigo-service-code-selection"
                      options={serviceListToShow}
                      disabled={loading || selectedFamilyMember == null}
                      value={serviceSelected}
                      onChange={(e, v) => {
                        if (v) {
                          if (serviceSelected != null) {
                            resetValues(5);
                          }
                          setServiceSelected(v);
                        } else {
                          setServiceSelected(null);

                          resetValues(5);
                        }
                      }}
                      getOptionLabel={(option) => {
                        if (!option) return "";
                        const serviceId = option.serviceId ?? "";
                        const serviceCode = option.serviceCode ?? "";
                        const modes =
                          option.serviceModeDetails
                            ?.map((m) => m.modeName)
                            .join(" / ") ?? "";
                        const name = option.name ?? "";
                        let priceText = "";
                        if (
                          Array.isArray(option.serviceModeDetails) &&
                          option.serviceModeDetails.length > 0
                        ) {
                          const price =
                            option.serviceModeDetails[0]?.discountedPrice;
                          if (option.serviceModeDetails.length === 1) {
                            priceText =
                              price !== undefined && price !== null
                                ? ` (at Rs. ${price})`
                                : "";
                          } else {
                            priceText =
                              price !== undefined && price !== null
                                ? ` (starting from Rs. ${price})`
                                : "";
                          }
                        }
                        return `(${serviceId}) ${serviceCode} / ${name} (${modes})${priceText}`;
                      }}
                      filterOptions={(options, { inputValue }) => {
                        const searchText = inputValue.toLowerCase();

                        return options.filter((option) => {
                          const serviceId = String(option.serviceId ?? "");
                          const serviceCode =
                            option.serviceCode?.toLowerCase() ?? "";
                          const name = option.name?.toLowerCase() ?? "";
                          const modes =
                            option.serviceModeDetails
                              ?.map((m) => m.modeName.toLowerCase())
                              .join(" / ") ?? "";

                          return (
                            serviceId.includes(searchText) ||
                            serviceCode.includes(searchText) ||
                            name.includes(searchText) ||
                            modes.includes(searchText)
                          );
                        });
                      }}
                      renderInput={(params) => (
                        <TextField2
                          {...params}
                          placeholder="Select"
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              fontFamily: "Montserrat, sans-serif",
                              marginTop: "8px",
                            },
                            classes: {
                              underline: "custom-underline",
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs={12} sm={5} md={5} lg={5}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    {`Select service mode`}
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div>
                    <Autocomplete
                      id="mp-navigo-service-mode-selection"
                      options={serviceModeList}
                      disabled={loading || serviceSelected == null}
                      value={serviceModeSelected}
                      onChange={(e, v) => {
                        if (v) {
                          if (serviceModeSelected != null) {
                            resetValues(6);
                          }
                          setServiceModeSelected(v);
                        } else {
                          setServiceModeSelected(null);

                          resetValues(6);
                        }
                      }}
                      getOptionLabel={(option) => {
                        if (!option) return "";
                        const modeDetail =
                          serviceSelected?.serviceModeDetails?.find(
                            (m) => m.modeName === option,
                          );

                        if (!modeDetail) return option;

                        if (modeDetail.hasDifferentialPricing) {
                          return `${option} (price varies on service provider)`;
                        } else {
                          return `${option} (Rs ${modeDetail.discountedPrice})`;
                        }
                      }}
                      filterOptions={(options, { inputValue }) => {
                        const searchText = inputValue.toLowerCase();

                        return options.filter((option) => {
                          const serviceMode = option.toLowerCase() || "";

                          return serviceMode.includes(searchText);
                        });
                      }}
                      renderInput={(params) => (
                        <TextField2
                          {...params}
                          placeholder="Select"
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              fontFamily: "Montserrat, sans-serif",
                              marginTop: "8px",
                            },
                            classes: {
                              underline: "custom-underline",
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <br />
            {(serviceModeSelected === MODES.CENTRE_VISIT ||
              serviceModeSelected === MODES.CAMP_SITE_VISIT) && (
              <>
                <Row>
                  <Col xs={12} sm={3} md={3} lg={3}>
                    <div className="navigo-module-create-service-field-container">
                      <div className="navigo-module-label">
                        {`Select location mode`}
                        <label className="navigo-module-label-red"> *</label>
                      </div>
                      <div>
                        <Autocomplete
                          id="mp-navigo-location-mode-selection"
                          options={SELECT_LOCATION_MODE_OPTIONS}
                          getOptionLabel={(option) => option.label}
                          value={locationModeSelected}
                          disabled={loading}
                          isOptionEqualToValue={(option, value) =>
                            option.value === value?.value
                          }
                          onChange={(e, v) => {
                            if (v) {
                              setLocationModeSelected(v);
                            } else {
                              setLocationModeSelected(null);
                            }
                            resetValues(10);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              placeholder="Select"
                              InputProps={{
                                ...params.InputProps,
                                style: {
                                  fontFamily: "Montserrat, sans-serif",
                                  marginTop: "8px",
                                },
                                classes: {
                                  underline: "custom-underline",
                                },
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  {locationModeSelected?.value == LOCATION_MODE.GOOGLE_MAPS && (
                    <>
                      <Col xs={12} sm={1} md={1} lg={1}>
                        <div style={{ height: "20px" }}></div>
                      </Col>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div style={{ marginTop: "14px", width: "175px" }}>
                          <Button
                            className={
                              !geoLocData?.latLng
                                ? "zy-btn-blue-1"
                                : "zy-btn-orange-1"
                            }
                            onClick={() => {
                              handleOpenLocationPicker();
                            }}
                          >
                            {!geoLocData?.latLng
                              ? "Choose location"
                              : "Change location"}
                          </Button>
                        </div>
                      </Col>
                    </>
                  )}
                </Row>

                {locationModeSelected?.value == LOCATION_MODE.GOOGLE_MAPS &&
                  geoLocData?.latLng !== null && (
                    <>
                      <br />
                      <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div className="navigo-module-create-service-field-container">
                            <div className="navigo-module-label">
                              {`Location`}
                            </div>
                            <div>
                              <TextField
                                value={formatAddress(geoLocData?.address) ?? ""}
                                lineDirection="left"
                                disabled
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}

                {locationModeSelected?.value == "MANUAL" && (
                  <>
                    <br />
                    <Row>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            {`Select state`}
                            <label className="navigo-module-label-red">
                              {" "}
                              *
                            </label>
                          </div>
                          <div>
                            <Autocomplete
                              id="mp-navigo-state-selection"
                              options={stateList}
                              disabled={loading}
                              value={stateSelected}
                              onChange={(e, v) => {
                                if (v) {
                                  if (stateSelected != null) {
                                    resetValues(8);
                                    setCityList([]);
                                    setCitySelected(null);
                                    setLocalityList([]);
                                    setLocalitySelected(null);
                                  }
                                  getSPByFilters(v, null, null);
                                  setStateSelected(v);
                                } else {
                                  setStateSelected(null);

                                  resetValues(8);
                                  setCityList([]);
                                  setCitySelected(null);
                                  setLocalityList([]);
                                  setLocalitySelected(null);
                                  // getProviderOfPlanService(serviceModeSelected);
                                  getSPByFilters(null, null, null);
                                }
                              }}
                              getOptionLabel={(option) =>
                                option ? option : ""
                              }
                              filterOptions={(options, { inputValue }) => {
                                const searchText = inputValue.toLowerCase();

                                return options.filter((option) => {
                                  const state = option.toLowerCase() || "";

                                  return state.includes(searchText);
                                });
                              }}
                              renderInput={(params) => (
                                <TextField2
                                  {...params}
                                  placeholder="Select"
                                  InputProps={{
                                    ...params.InputProps,
                                    style: {
                                      fontFamily: "Montserrat, sans-serif",
                                      marginTop: "8px",
                                    },
                                    classes: {
                                      underline: "custom-underline",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={1} md={1} lg={1}>
                        <div style={{ height: "20px" }}></div>
                      </Col>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            {`Select city`}
                            <label className="navigo-module-label-red">
                              {" "}
                              *
                            </label>
                          </div>
                          <div>
                            <Autocomplete
                              id="mp-navigo-city-selection"
                              options={cityList}
                              disabled={loading || stateSelected === null}
                              value={citySelected}
                              onChange={(e, v) => {
                                if (v) {
                                  if (citySelected != null) {
                                    resetValues(8);

                                    setLocalityList([]);
                                    setLocalitySelected(null);
                                  }

                                  setCitySelected(v);
                                } else {
                                  setCitySelected(null);

                                  resetValues(8);
                                  getSPByFilters(stateSelected, null, null);
                                  setLocalityList([]);
                                  setLocalitySelected(null);
                                }
                              }}
                              getOptionLabel={(option) =>
                                option ? option : ""
                              }
                              filterOptions={(options, { inputValue }) => {
                                const searchText = inputValue.toLowerCase();

                                return options.filter((option) => {
                                  const city = option.toLowerCase() || "";

                                  return city.includes(searchText);
                                });
                              }}
                              renderInput={(params) => (
                                <TextField2
                                  {...params}
                                  placeholder="Select"
                                  InputProps={{
                                    ...params.InputProps,
                                    style: {
                                      fontFamily: "Montserrat, sans-serif",
                                      marginTop: "8px",
                                    },
                                    classes: {
                                      underline: "custom-underline",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={1} md={1} lg={1}>
                        <div style={{ height: "20px" }}></div>
                      </Col>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">{`Select locality`}</div>
                          <div>
                            <Autocomplete
                              id="mp-navigo-locality-selection"
                              options={localityList}
                              disabled={loading || citySelected === null}
                              value={localitySelected}
                              onChange={(e, v) => {
                                if (v) {
                                  // if (localitySelected != null) {
                                  //   resetValues(8);
                                  // }
                                  resetValues(8);
                                  getSPByFilters(
                                    stateSelected,
                                    citySelected,
                                    v,
                                  );
                                  setLocalitySelected(v);
                                } else {
                                  setLocalitySelected(null);

                                  resetValues(8);
                                  getSPByFilters(
                                    stateSelected,
                                    citySelected,
                                    null,
                                  );
                                }
                              }}
                              getOptionLabel={(option) =>
                                option ? option : ""
                              }
                              filterOptions={(options, { inputValue }) => {
                                const searchText = inputValue.toLowerCase();

                                return options.filter((option) => {
                                  const locality = option.toLowerCase() || "";

                                  return locality.includes(searchText);
                                });
                              }}
                              renderInput={(params) => (
                                <TextField2
                                  {...params}
                                  placeholder="Select"
                                  InputProps={{
                                    ...params.InputProps,
                                    style: {
                                      fontFamily: "Montserrat, sans-serif",
                                      marginTop: "8px",
                                    },
                                    classes: {
                                      underline: "custom-underline",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
                {locationModeSelected?.value == "SAVED_ADDRESSES" && (
                  <>
                    <br />
                    <Row>
                      <Col xs={12} sm={5} md={5} lg={5}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            {`Select address`}
                            <label className="navigo-module-label-red">
                              {" "}
                              *
                            </label>
                          </div>
                          <div>
                            <Autocomplete
                              id="mp-navigo-address-selection"
                              options={addressList}
                              value={addressSelected}
                              disabled={loading || serviceModeSelected == null}
                              onOpen={() => {
                                getPatientAddress();
                              }}
                              onChange={(e, v) => {
                                resetValues(11);
                                if (v) {
                                  setLoading(true);
                                  getLocationFromSavedAddress(v);
                                } else {
                                  setAddressSelected(null);
                                }
                              }}
                              getOptionLabel={(option) =>
                                option
                                  ? `${option.line1}, ${option.line2}, ${
                                      option.landmark && option.landmark != ""
                                        ? `${option.landmark}, `
                                        : ""
                                    }${option.city}, ${option.district}, ${
                                      option.state
                                    } - ${option.pincode}`
                                  : ""
                              }
                              filterOptions={(options, { inputValue }) => {
                                const searchText = inputValue.toLowerCase();

                                return options.filter((option) => {
                                  const addressString = [
                                    option.line1,
                                    option.line2,
                                    option.landmark,
                                    option.city,
                                    option.district,
                                    option.state,
                                    option.pincode,
                                  ]
                                    .filter(Boolean)
                                    .join(", ")
                                    .toLowerCase();

                                  return addressString.includes(searchText);
                                });
                              }}
                              renderInput={(params) => (
                                <TextField2
                                  {...params}
                                  placeholder="Select"
                                  InputProps={{
                                    ...params.InputProps,
                                    style: {
                                      fontFamily: "Montserrat, sans-serif",
                                      marginTop: "8px",
                                    },
                                    classes: {
                                      underline: "custom-underline",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
                <br />
                <Row>
                  {(locationModeSelected?.value == "GOOGLE_MAPS" ||
                    locationModeSelected?.value == "SAVED_ADDRESSES") &&
                    geoLocData?.latLng !== null && (
                      <>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="navigo-module-create-service-field-container">
                            <div className="navigo-module-label">
                              {`Area radius`}
                              <label className="navigo-module-label-red">
                                {" "}
                                *
                              </label>
                            </div>
                            <div>
                              <Autocomplete
                                id="mp-navigo-service-range1-selection"
                                options={LOCATION_RANGE_KMS_OPTIONS}
                                value={rangeOptionSelected}
                                disabled={
                                  loading ||
                                  geoLocData?.latLng == null ||
                                  (addressSelected == null &&
                                    locationModeSelected?.value ==
                                      LOCATION_MODE.SAVED_ADDRESSES)
                                }
                                getOptionLabel={(option) => option?.label ?? ""}
                                isOptionEqualToValue={(option, value) =>
                                  option?.value === value?.value
                                }
                                onChange={(e, v) => {
                                  resetValues(12);
                                  handleRadiusKmSelected(
                                    v,
                                    false,
                                    geoLocData?.latLng,
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField2
                                    {...params}
                                    placeholder="Select"
                                    InputProps={{
                                      ...params.InputProps,
                                      style: {
                                        fontFamily: "Montserrat, sans-serif",
                                        marginTop: "8px",
                                      },
                                      classes: {
                                        underline: "custom-underline",
                                      },
                                    }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                      </>
                    )}
                </Row>
              </>
            )}

            {serviceModeSelected === MODES.HOME_SAMPLE && (
              <>
                <Row>
                  <Col xs={12} sm={5} md={5} lg={5}>
                    <div className="navigo-module-create-service-field-container">
                      <div className="navigo-module-label">
                        {`Select address`}
                        <label className="navigo-module-label-red"> *</label>
                      </div>
                      <div>
                        <Autocomplete
                          id="mp-navigo-address-selection"
                          options={addressList}
                          value={addressSelected}
                          disabled={loading || serviceModeSelected == null}
                          onOpen={() => {
                            getPatientAddress();
                          }}
                          onChange={(e, v) => {
                            resetValues(8);
                            if (v) {
                              handleAddressSelectWithValidation(v);
                            } else {
                              setAddressSelected(null);
                            }
                          }}
                          getOptionLabel={(option) =>
                            option
                              ? `${option.line1}, ${option.line2}, ${
                                  option.landmark && option.landmark != ""
                                    ? `${option.landmark}, `
                                    : ""
                                }${option.city}, ${option.district}, ${
                                  option.state
                                } - ${option.pincode}`
                              : ""
                          }
                          filterOptions={(options, { inputValue }) => {
                            const searchText = inputValue.toLowerCase();

                            return options.filter((option) => {
                              const addressString = [
                                option.line1,
                                option.line2,
                                option.landmark,
                                option.city,
                                option.district,
                                option.state,
                                option.pincode,
                              ]
                                .filter(Boolean)
                                .join(", ")
                                .toLowerCase();

                              return addressString.includes(searchText);
                            });
                          }}
                          renderOption={(option) => {
                            const hasValidCoordinates =
                              option?.coordinates &&
                              option.coordinates.latitude !== 0 &&
                              option.coordinates.longitude !== 0;

                            const label = option
                              ? `${option.line1}, ${option.line2}, ${
                                  option.landmark && option.landmark !== ""
                                    ? `${option.landmark}, `
                                    : ""
                                }${option.city}, ${option.district}, ${option.state} - ${option.pincode}`
                              : "";

                            return (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                {!hasValidCoordinates && (
                                  <span
                                    style={{
                                      marginRight: 8,
                                      padding: "2px 8px",
                                      fontSize: 12,
                                      borderRadius: 12,
                                      backgroundColor: "#E9E7FE",
                                      color: "#6A5FF5",
                                      fontWeight: 600,
                                      cursor: "pointer",
                                      display: "inline-flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    Update
                                  </span>
                                )}

                                <span>{label}</span>
                              </div>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              placeholder="Select"
                              InputProps={{
                                ...params.InputProps,
                                style: {
                                  fontFamily: "Montserrat, sans-serif",
                                  marginTop: "8px",
                                },
                                classes: {
                                  underline: "custom-underline",
                                },
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} sm={1} md={1} lg={1}>
                    {!(loading || serviceModeSelected == null) && (
                      /* Profile-v2's Addresses section, with a new address
                         already started: "?address=true" is the legacy
                         profile's own flag, answered there now
                         (profile-v2/index.js _openAddressFromUrl), and it
                         scrolls the section into view. A NEW TAB is kept —
                         the operator is mid-booking, and taking this screen
                         away would lose what they have typed
                         (Nittin, 2026-09-25). */
                      <Link
                        to={`/profile-v2/${patientDetails?.id}?address=true`}
                        target="_blank"
                        className="navigo-module-add-more"
                        style={{ height: "20px" }}
                      >
                        + Add new
                      </Link>
                    )}
                  </Col>
                </Row>
                <br />
              </>
            )}

            <Row>
              <Col xs={12} sm={11} md={11} lg={11}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div>
                    <Checkbox
                      id="mp-appointment-checkbox-3"
                      name="mp-appointment-checkbox-3"
                      style={{ marginLeft: -13, marginTop: 3 }}
                      disabled={
                        !isAutoSPAllowed(serviceModeSelected) ||
                        ((serviceModeSelected === MODES.CENTRE_VISIT ||
                          serviceModeSelected === MODES.CAMP_SITE_VISIT) &&
                          citySelected == null &&
                          !rangeOptionSelected) ||
                        loading ||
                        serviceModeSelected == null ||
                        (serviceModeSelected === MODES.HOME_SAMPLE &&
                          addressSelected == null)
                      }
                      // color={mode == 2 ? "default" : "secondary"}
                      checked={selectServiceProviderCheckbox}
                      onChange={(value, proxy) => {
                        setDateSelected(null);
                        setSlotSelected(null);
                        setSlotList([]);
                        setServiceProviderSelected(null);
                        setServiceProviderAutoSelected(null);
                        if (selectServiceProviderCheckbox) {
                          setSelectServiceProviderCheckbox(false);
                        } else {
                          setSelectServiceProviderCheckbox(true);
                        }
                      }}
                    />
                  </div>
                  <div className="navigo-module-label-checkbox">
                    {`Select service provider or check mark to select automatically`}{" "}
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                </div>

                <div
                  className="navigo-module-checkbox-field-container"
                  style={{ marginTop: "-16px" }}
                >
                  <div>
                    <Autocomplete
                      id="mp-navigo-service-provider-selection"
                      options={serviceProviderListToShow}
                      value={serviceProviderSelected}
                      disabled={
                        selectServiceProviderCheckbox ||
                        ((serviceModeSelected === MODES.CENTRE_VISIT ||
                          serviceModeSelected === MODES.CAMP_SITE_VISIT) &&
                          citySelected == null &&
                          !rangeOptionSelected) ||
                        loading ||
                        serviceModeSelected == null ||
                        (serviceModeSelected === MODES.HOME_SAMPLE &&
                          addressSelected == null)
                      }
                      onChange={(e, v) => {
                        if (v) {
                          if (serviceProviderSelected != null) {
                            resetValues(7);
                          }
                          setServiceProviderSelected(v);
                        } else {
                          setServiceProviderSelected(null);

                          resetValues(7);
                        }
                      }}
                      getOptionLabel={(option) =>
                        getSPLabelTypeHC(option, serviceModeSelected)
                      }
                      filterOptions={
                        serviceModeSelected === MODES.CENTRE_VISIT ||
                        serviceModeSelected === MODES.CAMP_SITE_VISIT
                          ? (options, { inputValue }) => {
                              const searchText = inputValue.toLowerCase();
                              return options.filter((option) => {
                                if (
                                  addressNotServiceableForPriorityVendors &&
                                  priorityVendorMappedSpIds.includes(option.id)
                                ) {
                                  return false;
                                }
                                const label = `(${option.id}) ${
                                  option.name
                                } - ${option?.address?.city ?? ""} - ${
                                  option?.address?.landmark ?? ""
                                }`.toLowerCase();
                                return label.includes(searchText);
                              });
                            }
                          : (options, { inputValue }) => {
                              const searchText = inputValue.toLowerCase();
                              return options.filter((option) => {
                                if (
                                  addressNotServiceableForPriorityVendors &&
                                  priorityVendorMappedSpIds.includes(option.id)
                                ) {
                                  return false;
                                }
                                const label =
                                  `(${option.id}) ${option.name}`.toLowerCase();
                                return label.includes(searchText);
                              });
                            }
                      }
                      renderOption={(option, state) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {option?.margin?.colour ? (
                            <span
                              style={{
                                width: 12,
                                height: 12,
                                borderRadius: "50%",
                                backgroundColor: option.margin.colour,
                                marginRight: 8,
                              }}
                            />
                          ) : null}

                          {getSPLabelTypeHC(option, serviceModeSelected)}
                        </div>
                      )}
                      renderInput={(params) => (
                        <TextField2
                          {...params}
                          multiline
                          placeholder={"Select"}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: serviceProviderSelected?.margin
                              ?.colour ? (
                              <span
                                style={{
                                  width: 12,
                                  height: 12,
                                  borderRadius: "50%",
                                  backgroundColor:
                                    serviceProviderSelected.margin.colour,
                                  marginRight: 8,
                                  marginLeft: 4,
                                }}
                              />
                            ) : null,

                            style: {
                              fontFamily: "Montserrat, sans-serif",
                              marginTop: "8px",
                            },
                            classes: {
                              underline: "custom-underline",
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </Col>
              {(locationModeSelected?.value == "GOOGLE_MAPS" ||
                locationModeSelected?.value == "SAVED_ADDRESSES") &&
                serviceProviderSelected && (
                  <>
                    <Col xs={12} sm={3} md={3} lg={3}>
                      <div
                        className="navigo-module-create-service-field-container"
                        style={{ margin: "14px 0px 0px 0px" }}
                      >
                        <div className="navigo-module-label">
                          {`Distance from location provider`}
                        </div>
                        <div>
                          <TextField
                            value={formatDistanceKm(
                              serviceProviderSelected?.distanceFromSource,
                            )}
                            lineDirection="left"
                            disabled
                          />
                        </div>
                      </div>
                    </Col>
                  </>
                )}
            </Row>
            {serviceProviderSelected &&
              serviceProviderSelected?.amenities?.breakfastAvailable ==
                true && (
                <>
                  <br />
                  <Row>
                    <div
                      className="navigo-module-create-service-field-container"
                      style={{ marginLeft: "6px" }}
                    >
                      <div className="navigo-module-label">{`Amenities`}</div>
                      <div className="navigo-module-info-badge">
                        {"Breakfast available"}
                      </div>
                    </div>
                  </Row>
                </>
              )}

            {(serviceModeSelected === MODES.CENTRE_VISIT ||
              serviceModeSelected === MODES.CAMP_SITE_VISIT) && (
              <>
                <br />
                <Row>
                  <Col xs={12} sm={8} md={8} lg={8}>
                    <div className="navigo-module-create-service-field-container">
                      <div className="navigo-module-label">
                        {`Google map link`}
                      </div>
                      <div>
                        <TextField
                          value={
                            serviceProviderSelected?.address?.googleMapLink ??
                            ""
                          }
                          lineDirection="left"
                          disabled
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </>
            )}
            <br />

            <Row>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    {`Choose date`}
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div style={{ paddingTop: "10px" }}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                        style={{ width: "100%" }}
                        value={dateSelected}
                        onChange={(date) => {
                          setDateSelected(date);
                        }}
                        onOpen={() => {
                          setDatePickerOpened(true);
                        }}
                        onClose={() => {
                          setDatePickerOpened(false);
                        }}
                        autoOk={true}
                        disabled={
                          loading ||
                          (addressSelected == null &&
                            serviceModeSelected === MODES.HOME_SAMPLE) ||
                          (serviceProviderSelected == null &&
                            selectServiceProviderCheckbox == false) ||
                          areDatesAvailable2(
                            serviceModeSelected,
                            homeSampleDateMin,
                            homeSampleDateMax,
                            selectServiceProviderCheckbox,
                            serviceProviderSelected,
                          ) === false
                        }
                        className="navigo-module-appointment-datepicker"
                        format="DD MMM YYYY"
                        placeholder="DD MMM YYYY"
                        keyboardIcon={<FontIcon>calendar_month</FontIcon>}
                        variant="inline"
                        minDate={getMinDate2(
                          serviceModeSelected,
                          homeSampleDateMin,
                          selectServiceProviderCheckbox,
                          serviceProviderSelected,
                        )}
                        maxDate={getMaxDate2(
                          serviceModeSelected,
                          homeSampleDateMax,
                          selectServiceProviderCheckbox,
                          serviceProviderSelected,
                        )}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    {`Choose timeslot`}
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div>
                    <Autocomplete
                      id="mp-navigo-slot-selection"
                      value={slotSelected}
                      disabled={loading || dateSelected === null}
                      options={slotList}
                      onChange={(e, v) => {
                        if (v) {
                          setSlotSelected(v);
                        } else {
                          setSlotSelected(null);
                        }
                      }}
                      getOptionLabel={(option) =>
                        option ? intToTime12(option.value) : ""
                      }
                      renderInput={(params) => (
                        <TextField2
                          {...params}
                          placeholder="Choose timeslot"
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              fontFamily: "Montserrat, sans-serif",
                              marginTop: "8px",
                            },
                            classes: {
                              underline: "custom-underline",
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            {renderTotalAmountAndCreateAptBtn()}
          </div>
        ) : serviceTypeSelected?.serviceTypeId == SERVICE_TYPE.GYM ? (
          <div>
            <Row>
              <Col xs={12} sm={11} md={11} lg={11}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    {`Select service code/name`}
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div>
                    <Autocomplete
                      id="mp-navigo-service-code-selection"
                      options={serviceListToShow}
                      disabled={loading || selectedFamilyMember == null}
                      value={serviceSelected}
                      onChange={(e, v) => {
                        if (v) {
                          if (serviceSelected != null) {
                            resetValues(5);
                          }
                          setServiceSelected(v);
                        } else {
                          setServiceSelected(null);

                          resetValues(5);
                        }
                      }}
                      getOptionLabel={(option) => {
                        if (!option) return "";
                        const serviceId = option.serviceId ?? "";
                        const serviceCode = option.serviceCode ?? "";
                        const modes =
                          option.serviceModeDetails
                            ?.map((m) => m.modeName)
                            .join(" / ") ?? "";
                        const name = option.name ?? "";
                        let priceText = "";
                        if (
                          Array.isArray(option.serviceModeDetails) &&
                          option.serviceModeDetails.length > 0
                        ) {
                          const price =
                            option.serviceModeDetails[0]?.discountedPrice;
                          if (option.serviceModeDetails.length === 1) {
                            priceText =
                              price !== undefined && price !== null
                                ? ` (at Rs. ${price})`
                                : "";
                          } else {
                            priceText =
                              price !== undefined && price !== null
                                ? ` (starting from Rs. ${price})`
                                : "";
                          }
                        }
                        return `(${serviceId}) ${serviceCode} / ${name} (${modes})${priceText}`;
                      }}
                      filterOptions={(options, { inputValue }) => {
                        const searchText = inputValue.toLowerCase();

                        return options.filter((option) => {
                          const serviceId = String(option.serviceId ?? "");
                          const serviceCode =
                            option.serviceCode?.toLowerCase() ?? "";
                          const name = option.name?.toLowerCase() ?? "";
                          const modes =
                            option.serviceModeDetails
                              ?.map((m) => m.modeName.toLowerCase())
                              .join(" / ") ?? "";

                          return (
                            serviceId.includes(searchText) ||
                            serviceCode.includes(searchText) ||
                            name.includes(searchText) ||
                            modes.includes(searchText)
                          );
                        });
                      }}
                      renderInput={(params) => (
                        <TextField2
                          {...params}
                          placeholder="Select"
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              fontFamily: "Montserrat, sans-serif",
                              marginTop: "8px",
                            },
                            classes: {
                              underline: "custom-underline",
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs={12} sm={5} md={5} lg={5}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    {`Select service mode`}
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div>
                    <Autocomplete
                      id="mp-navigo-service-mode-selection"
                      options={serviceModeList}
                      disabled={loading || serviceSelected == null}
                      value={serviceModeSelected}
                      onChange={(e, v) => {
                        if (v) {
                          if (serviceModeSelected != null) {
                            resetValues(6);
                          }
                          setServiceModeSelected(v);
                        } else {
                          setServiceModeSelected(null);

                          resetValues(6);
                        }
                      }}
                      getOptionLabel={(option) => {
                        if (!option) return "";
                        const modeDetail =
                          serviceSelected?.serviceModeDetails?.find(
                            (m) => m.modeName === option,
                          );

                        if (!modeDetail) return option;

                        if (modeDetail.hasDifferentialPricing) {
                          return `${option} (price varies on service provider)`;
                        } else {
                          return `${option} (Rs ${modeDetail.discountedPrice})`;
                        }
                      }}
                      filterOptions={(options, { inputValue }) => {
                        const searchText = inputValue.toLowerCase();

                        return options.filter((option) => {
                          const serviceMode = option.toLowerCase() || "";

                          return serviceMode.includes(searchText);
                        });
                      }}
                      renderInput={(params) => (
                        <TextField2
                          {...params}
                          placeholder="Select"
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              fontFamily: "Montserrat, sans-serif",
                              marginTop: "8px",
                            },
                            classes: {
                              underline: "custom-underline",
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <br />

            <Row>
              <Col xs={12} sm={5} md={5} lg={5}>
                <div
                  className="navigo-module-checkbox-field-container"
                  style={{ marginTop: "-16px" }}
                >
                  <div>
                    <div className="navigo-module-label-checkbox">
                      {`Select service provider`}{" "}
                      <label className="navigo-module-label-red"> *</label>
                    </div>
                    <Autocomplete
                      id="mp-navigo-service-provider-selection"
                      options={serviceProviderListToShow}
                      value={serviceProviderSelected}
                      disabled={loading || serviceModeSelected == null}
                      onChange={(e, v) => {
                        if (v) {
                          if (serviceProviderSelected != null) {
                            resetValues(7);
                          }
                          setServiceProviderSelected(v);
                          setBaseCityListToShow(v?.baseCity?.baseCities ?? []);
                          const baseCities = v?.baseCity?.baseCities;

                          if (!baseCities || baseCities.length === 0) {
                            const finalPrice = v?.price;

                            if (
                              finalPrice != null &&
                              !isNaN(finalPrice) &&
                              finalPrice >= 0
                            ) {
                              setAptPrice(finalPrice);
                            }
                          } else {
                            setAptPrice(null);
                          }
                        } else {
                          setServiceProviderSelected(null);
                          setBaseCityListToShow(null);
                          setAptPrice(null);
                          resetValues(7);
                        }
                      }}
                      getOptionLabel={(option) =>
                        option
                          ? option?.hasDifferentialPricing
                            ? `(${option.id}) ${option.name} (price varies on base city)`
                            : `(${option.id}) ${option.name} (Rs ${option.price})`
                          : ""
                      }
                      filterOptions={(options, { inputValue }) => {
                        const searchText = inputValue.toLowerCase();
                        return options.filter((option) => {
                          const label =
                            `(${option.id}) ${option.name}`.toLowerCase();
                          return label.includes(searchText);
                        });
                      }}
                      renderOption={(option, state) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {option?.margin?.colour ? (
                            <span
                              style={{
                                width: 12,
                                height: 12,
                                borderRadius: "50%",
                                backgroundColor: option.margin.colour,
                                marginRight: 8,
                              }}
                            />
                          ) : null}

                          {option?.hasDifferentialPricing
                            ? `(${option.id}) ${option.name} (price varies on base city)`
                            : `(${option.id}) ${option.name} (Rs ${option.price})`}
                        </div>
                      )}
                      renderInput={(params) => (
                        <TextField2
                          {...params}
                          placeholder={"Select"}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: serviceProviderSelected?.margin
                              ?.colour ? (
                              <span
                                style={{
                                  width: 12,
                                  height: 12,
                                  borderRadius: "50%",
                                  backgroundColor:
                                    serviceProviderSelected.margin.colour,
                                  marginRight: 8,
                                  marginLeft: 4,
                                }}
                              />
                            ) : null,
                            style: {
                              fontFamily: "Montserrat, sans-serif",
                              marginTop: "8px",
                            },
                            classes: {
                              underline: "custom-underline",
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            <br />

            {Boolean((baseCityListToShow ?? []).length > 0) && (
              <Row>
                <Col xs={12} sm={5} md={5} lg={5}>
                  <div
                    className="navigo-module-checkbox-field-container"
                    style={{ marginTop: "-16px" }}
                  >
                    <div>
                      <div className="navigo-module-label-checkbox">
                        {`Select base city`}{" "}
                        <label className="navigo-module-label-red"> *</label>
                      </div>
                      <Autocomplete
                        id="mp-navigo-service-provider-selection"
                        options={baseCityListToShow}
                        value={baseCitySelected}
                        disabled={!Boolean(serviceProviderSelected) || loading}
                        onChange={(e, v) => {
                          if (v) {
                            if (baseCitySelected != null) {
                              resetValues(7);
                            }
                            setBaseCitySelected(v);
                          } else {
                            setBaseCitySelected(null);

                            resetValues(7);
                          }
                        }}
                        getOptionLabel={(option) =>
                          option ? `${option.city} (Rs ${option.price})` : ""
                        }
                        filterOptions={(options, { inputValue }) => {
                          const searchText = inputValue.toLowerCase();
                          return options.filter((option) => {
                            const label =
                              `${option.city} (Rs ${option.price})`.toLowerCase();
                            return label.includes(searchText);
                          });
                        }}
                        renderInput={(params) => (
                          <TextField2
                            {...params}
                            placeholder={"Select"}
                            InputProps={{
                              ...params.InputProps,
                              style: {
                                fontFamily: "Montserrat, sans-serif",
                                marginTop: "8px",
                              },
                              classes: {
                                underline: "custom-underline",
                              },
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            )}

            <br />

            <Row>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    {`Subscription mobile number`}
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div>
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "40px", marginRight: "20px" }}>
                        <TextField
                          value={
                            gymSubscriptionMetaData?.countryCode
                              ? `+${gymSubscriptionMetaData.countryCode}`
                              : ""
                          }
                          lineDirection="left"
                          disabled
                        />
                      </div>
                      <div style={{ flex: "1" }}>
                        <TextField
                          value={
                            gymSubscriptionMetaData?.phoneNo
                              ? `${gymSubscriptionMetaData.phoneNo}`
                              : ""
                          }
                          lineDirection="left"
                          disabled={
                            loading || !Boolean(serviceProviderSelected)
                          }
                          onChange={(v, e) => {
                            let value = v.replace(/\D/g, "");

                            if (value.length <= 10) {
                              setPatientContactNumber(
                                value === "" ? "" : Number(value),
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    {`Subscription Email ID`}
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div>
                    <TextField
                      value={
                        gymSubscriptionMetaData?.email
                          ? `${gymSubscriptionMetaData?.email}`
                          : ""
                      }
                      lineDirection="left"
                      disabled={loading || !Boolean(serviceProviderSelected)}
                      onChange={(v, e) =>
                        setGymSubscriptionMetaData((prev) => ({
                          ...prev,
                          email: v,
                        }))
                      }
                    />
                  </div>
                </div>
              </Col>
            </Row>
            {renderTotalAmountAndCreateAptBtn()}
          </div>
        ) : (
          <></>
        )}
      </div>
      {updatePatientInfoDialog && (
        <DialogContainer
          id="appointment-update-patient-info-dialog"
          visible={updatePatientInfoDialog}
          focusOnMount={false}
          onHide={() => {
            !loadingProfileUpdate && closePatientInfoDialog();
            setSelectedFamilyMember(null);
          }}
          width={"600px"}
          autosizeContent={true}
          // height="320px"
          style={{ maxHeight: "100vh", overflow: "auto" }}
        >
          <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ marginTop: "5px" }}>
                <h3>Update missing profile details</h3>
              </div>
              <div>
                <Button
                  raised
                  disabled={loadingProfileUpdate}
                  className={
                    loadingProfileUpdate
                      ? "navigo-module-button-save-disabled"
                      : "navigo-module-button-save-enabled"
                  }
                  onClick={() => {
                    updatePatientInfo(patientInfo);
                  }}
                >
                  {"Save"}
                </Button>
              </div>
            </div>
            <br />
            {patientInfo && (
              <>
                <Row>
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <div className="navigo-module-create-service-field-container">
                      <div className="navigo-module-label">{`User name`}</div>
                      <div>
                        <TextField
                          value={
                            patientInfo
                              ? `${patientInfo.firstName} ${patientInfo.lastName}`
                              : ""
                          }
                          lineDirection="left"
                          disabled
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <br />
                {isDOBEmpty(patientInfo) && (
                  <>
                    <Row>
                      <Col xs={12} sm={6} md={6} lg={6}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            {`Date of birth`}
                            <label className="navigo-module-label-red">*</label>
                          </div>
                          <div style={{ paddingTop: "10px" }}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                              <KeyboardDatePicker
                                style={{ width: "100%" }}
                                value={newDob}
                                onChange={(date) => {
                                  setNewDob(date);
                                }}
                                autoOk={true}
                                className="navigo-module-appointment-datepicker"
                                format="DD MMM YYYY"
                                placeholder="DD MMM YYYY"
                                keyboardIcon={
                                  <FontIcon>calendar_month</FontIcon>
                                }
                                variant="inline"
                                minDate={moment().subtract(100, "years")}
                                maxDate={moment()}
                              />
                            </MuiPickersUtilsProvider>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <br />
                  </>
                )}
                {isEmailEmpty(patientInfo) && (
                  <>
                    <Row>
                      <Col xs={12} sm={6} md={6} lg={6}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            {`Email Id`}
                          </div>
                          <div>
                            <TextField
                              value={newEmail}
                              lineDirection="left"
                              onChange={(e) => {
                                if (e.length <= 50) {
                                  setNewEmail(e.trim());
                                }
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <br />
                  </>
                )}
              </>
            )}
          </div>
        </DialogContainer>
      )}
      {
        <LocationSearchDialog
          dialogState={dialogState}
          setDialogState={setDialogState}
          closeDialog={closeDialog}
        />
      }
      {/* Address edit location picker */}
      <LocationSearchDialog
        dialogState={addrEditDialogState}
        setDialogState={addrEditSetDialogState}
        closeDialog={addrEditCloseDialog}
      />
      {/* Address edit flow dialog */}
      <AddressFlowDialog
        flowState={addrFlowState}
        setFlowState={setAddrFlowState}
        closeFlow={closeAddrFlow}
        openLocationDialog={addrEditOpenLocationDialog}
        patientId={patientDetails?.id}
      />
      {showPaymentLinkDialog &&
        aptPrice != null &&
        !isNaN(aptPrice) &&
        aptPrice >= 0 &&
        payloadForCreateAppointment && (
          <PaymentLinkDialog
            visible={showPaymentLinkDialog}
            onClose={() => {
              setShowPaymentLinkDialog(false);
              setLoading(false);
            }}
            withCreateAppointment={true} // must be passed for create appointment flow
            payloadForCreateAppointment={payloadForCreateAppointment} // must be passed for create appointment flow
            aptPrice={aptPrice} // must be passed for create appointment flow
            appointment={null} // We don't have appointment details on create appointment screen, so passing null.
            props={props}
            profileDetails={patientDetails}
          ></PaymentLinkDialog>
        )}
    </div>
  );
};

export default CreateAccount;
